/* tslint:disable */
/* eslint-disable */
import { UnitType, Language } from "./dto-app";

//  This file was automatically generated and should not be edited.

export type CreateDocumentNumberInput = {
  id?: string | null,
  format: string,
  lastUpdate: string,
  incrementNumber: number,
  type: ApplicationInvoiceType,
  _version?: number | null,
};

export enum ApplicationInvoiceType {
  INVOICE_SUBSCRIPTION = "INVOICE_SUBSCRIPTION",
  INVOICE_CREDIT = "INVOICE_CREDIT",
  CREDIT_NOTE = "CREDIT_NOTE",
}


export type ModelDocumentNumberConditionInput = {
  format?: AdminModelStringInput | null,
  lastUpdate?: AdminModelStringInput | null,
  incrementNumber?: AdminModelIntInput | null,
  type?: ModelApplicationInvoiceTypeInput | null,
  and?: Array< ModelDocumentNumberConditionInput | null > | null,
  or?: Array< ModelDocumentNumberConditionInput | null > | null,
  not?: ModelDocumentNumberConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type AdminModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: AdminModelAttributeTypes | null,
  size?: AdminModelSizeInput | null,
};

export enum AdminModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type AdminModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type AdminModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: AdminModelAttributeTypes | null,
};

export type ModelApplicationInvoiceTypeInput = {
  eq?: ApplicationInvoiceType | null,
  ne?: ApplicationInvoiceType | null,
};

export type AdminModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: AdminModelAttributeTypes | null,
};

export type DocumentNumberDTO = {
  __typename: "DocumentNumber",
  id: string,
  format: string,
  lastUpdate: string,
  incrementNumber: number,
  type: ApplicationInvoiceType,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateDocumentNumberInput = {
  id: string,
  format?: string | null,
  lastUpdate?: string | null,
  incrementNumber?: number | null,
  type?: ApplicationInvoiceType | null,
  _version?: number | null,
};

export type DeleteDocumentNumberInput = {
  id: string,
  _version?: number | null,
};

export type CancelConsumedCreditsInput = {
  clientId: string,
  numberOfOperations: number,
  requestId: string,
  type: CreditOperationType,
};

export enum CreditOperationType {
  OCR = "OCR",
  LETTER = "LETTER",
  REGISTERED_LETTER = "REGISTERED_LETTER",
  SIGNATURE = "SIGNATURE",
  SMS = "SMS",
  WHATSAPP = "WHATSAPP",
  PEPPOL = "PEPPOL",
}


export type CancelConsumedCreditsResponse = {
  __typename: "CancelConsumedCreditsResponse",
  creditsBalance: number,
  creditsCanceled: number,
  success: boolean,
};

export type ResendApplicationInvoiceToPeppolInput = {
  applicationInvoiceId: string,
};

export type ResendApplicationInvoiceToPeppolResponseDTO = {
  __typename: "ResendApplicationInvoiceToPeppolResponse",
  applicationInvoiceId: string,
  message?: string | null,
  success: boolean,
};

export type CreateAdminCommunicationInput = {
  id?: string | null,
  body: string,
  clientId: string,
  createdAt?: string | null,
  externalId?: string | null,
  applicationInvoiceId?: string | null,
  recipient?: string | null,
  sentAt?: string | null,
  status: AdminCommunicationStatus,
  subject: string,
  _version?: number | null,
};

export enum AdminCommunicationStatus {
  TO_SEND = "TO_SEND",
  SENT = "SENT",
  DELIVERED = "DELIVERED",
  BOUNCE_ERROR = "BOUNCE_ERROR",
}


export type ModelAdminCommunicationConditionInput = {
  body?: AdminModelStringInput | null,
  clientId?: AdminModelIDInput | null,
  createdAt?: AdminModelStringInput | null,
  externalId?: AdminModelIDInput | null,
  applicationInvoiceId?: AdminModelIDInput | null,
  recipient?: AdminModelStringInput | null,
  sentAt?: AdminModelStringInput | null,
  status?: ModelAdminCommunicationStatusInput | null,
  subject?: AdminModelStringInput | null,
  and?: Array< ModelAdminCommunicationConditionInput | null > | null,
  or?: Array< ModelAdminCommunicationConditionInput | null > | null,
  not?: ModelAdminCommunicationConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type AdminModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: AdminModelAttributeTypes | null,
  size?: AdminModelSizeInput | null,
};

export type ModelAdminCommunicationStatusInput = {
  eq?: AdminCommunicationStatus | null,
  ne?: AdminCommunicationStatus | null,
};

export type AdminCommunicationDTO = {
  __typename: "AdminCommunication",
  id: string,
  body: string,
  clientId: string,
  createdAt: string,
  externalId?: string | null,
  applicationInvoice?: ApplicationInvoiceDTO | null,
  applicationInvoiceId?: string | null,
  recipient?: string | null,
  sentAt?: string | null,
  status: AdminCommunicationStatus,
  subject: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ApplicationInvoiceDTO = {
  __typename: "ApplicationInvoice",
  id: string,
  amount: number,
  applicationSubscriptionId: string,
  applicationSubscription?: ApplicationSubscriptionDTO | null,
  clientId: string,
  createdAt: string,
  dueDate?: string | null,
  invoiceDate: string,
  invoiceLines?: ModelApplicationInvoiceLineConnection | null,
  invoiceNumber?: string | null,
  periodFrom: string,
  periodTo: string,
  clientSnapshot?: ApplicationInvoiceClientSnapshot | null,
  peppolProperties?: ApplicationInvoicePeppolProperties | null,
  status: ApplicationInvoiceStatus,
  type: ApplicationInvoiceType,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ApplicationSubscriptionDTO = {
  __typename: "ApplicationSubscription",
  id: string,
  clientId: string,
  creditsBalancePaid: number,
  creditsBalanceIncluded: number,
  creditsConfiguration: CreditsConfiguration,
  endDate?: string | null,
  language: Language,
  lastInvoiceDate?: string | null,
  paymentCustomerId?: string | null,
  paymentLastExecution?: string | null,
  paymentLastStatus: PaymentStatus,
  paymentLastError?: string | null,
  paymentMethodId?: string | null,
  paymentMode: PaymentMode,
  paymentTerms: PaymentTerms,
  invoicesProperties?: InvoicesProperties | null,
  plan?: ApplicationPlanDTO | null,
  planId: string,
  referenceNumber?: string | null,
  seller?: CompanyUserDTO | null,
  sellerId?: string | null,
  startDate: string,
  status: ApplicationSubscriptionStatus,
  subscriptionVariousOperations?: ModelApplicationSubscriptionVariousOperationConnection | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CreditsConfiguration = {
  __typename: "CreditsConfiguration",
  allowPostPaid: boolean,
  creditsNotification: Array< CustomerNotification >,
  postPaidThreshold: number,
};

export enum CustomerNotification {
  EMAIL = "EMAIL",
  IN_APP = "IN_APP",
}

export enum PaymentStatus {
  ACCOUNT_BLOCKED = "ACCOUNT_BLOCKED",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_INVALID = "ACCOUNT_INVALID",
  MANDATE_ACTIVE = "MANDATE_ACTIVE",
  MANDATE_ERROR = "MANDATE_ERROR",
  MANDATE_CHARGE_BACK = "MANDATE_CHARGE_BACK",
  MANDATE_REFUSED = "MANDATE_REFUSED",
  NO_MANDATE = "NO_MANDATE",
}


export enum PaymentMode {
  WIRE_TRANSFER = "WIRE_TRANSFER",
  AUTOMATIC_SEPA = "AUTOMATIC_SEPA",
}


export enum PaymentTerms {
  DAYS_5 = "DAYS_5",
  DAYS_15 = "DAYS_15",
  DAYS_30 = "DAYS_30",
}


export type InvoicesProperties = {
  __typename: "InvoicesProperties",
  hideQuantities?: boolean | null,
};

export type ApplicationPlanDTO = {
  __typename: "ApplicationPlan",
  id: string,
  calculationDetails:  Array<ApplicationPlanCalculationDetail >,
  calculationMethod: ApplicationPlanCalculationMethod,
  includedVariousOperations?: ModelApplicationVariousOperationConnection | null,
  isBillable: boolean,
  isDefaultPlan: boolean,
  labels:  Array<Label >,
  numberOfTrialMonths: number,
  setupFees: number,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ApplicationPlanCalculationDetail = {
  __typename: "ApplicationPlanCalculationDetail",
  amountType: ApplicationPlanCalculationAmountDetailType,
  endNumber?: number | null,
  feeApplied: number,
  minimumFixedUnitPriceThreshold?: number | null,
  startNumber: number,
  unitType: Array< UnitType >,
};

export enum ApplicationPlanCalculationAmountDetailType {
  PRICE = "PRICE",
  PERCENTAGE = "PERCENTAGE",
}

export enum ApplicationPlanCalculationMethod {
  NUMBER_OF_UNIT_PER_MONTH = "NUMBER_OF_UNIT_PER_MONTH",
  NUMBER_OF_UNIT_TYPE_PER_MONTH = "NUMBER_OF_UNIT_TYPE_PER_MONTH",
  PERCENTAGE_OF_UNIT_PRICE_PER_MONTH = "PERCENTAGE_OF_UNIT_PRICE_PER_MONTH",
}


export type ModelApplicationVariousOperationConnection = {
  __typename: "ModelApplicationVariousOperationConnection",
  items:  Array<ApplicationVariousOperationDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ApplicationVariousOperationDTO = {
  __typename: "ApplicationVariousOperation",
  id: string,
  amount: number,
  customerVisible: boolean,
  duration: ApplicationVariousOperationDuration,
  labels:  Array<Label >,
  numberOfCredits?: number | null,
  type: ApplicationVariousOperationType,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
  applicationPlanIncludedVariousOperationsId: string,
};

export enum ApplicationVariousOperationDuration {
  END_WITH_SUBSCRIPTION = "END_WITH_SUBSCRIPTION",
  ONE_TIME = "ONE_TIME",
  RECURRING = "RECURRING",
}


export type Label = {
  __typename: "Label",
  language: Language,
  label: string,
};

export enum ApplicationVariousOperationType {
  ADDON = "ADDON",
  DISCOUNT = "DISCOUNT",
  CREDIT = "CREDIT",
}


export type CompanyUserDTO = {
  __typename: "CompanyUser",
  id: string,
  cognitoSub?: string | null,
  email: string,
  firstName: string,
  language?: Language | null,
  lastName: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum ApplicationSubscriptionStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  DEACTIVATION_IN_PROCESS = "DEACTIVATION_IN_PROCESS",
  DISABLED = "DISABLED",
  ENDED = "ENDED",
  REACTIVATION_IN_PROCESS = "REACTIVATION_IN_PROCESS",
}


export type ModelApplicationSubscriptionVariousOperationConnection = {
  __typename: "ModelApplicationSubscriptionVariousOperationConnection",
  items:  Array<ApplicationSubscriptionVariousOperationDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ApplicationSubscriptionVariousOperationDTO = {
  __typename: "ApplicationSubscriptionVariousOperation",
  id: string,
  applicationSubscriptionId: string,
  applicationSubscription?: ApplicationSubscriptionDTO | null,
  clientId: string,
  createdAt: string,
  createdBy?: CompanyUserDTO | null,
  endDate?: string | null,
  label: string,
  lastInvoiceDate?: string | null,
  sellerId: string,
  startDate: string,
  subscriptionVariousOperationHistories:  Array<SubscriptionVariousOperationHistory >,
  type: ApplicationVariousOperationType,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type SubscriptionVariousOperationHistory = {
  __typename: "SubscriptionVariousOperationHistory",
  periodFrom: string,
  periodTo?: string | null,
  amount: number,
};

export type ModelApplicationInvoiceLineConnection = {
  __typename: "ModelApplicationInvoiceLineConnection",
  items:  Array<ApplicationInvoiceLineDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ApplicationInvoiceLineDTO = {
  __typename: "ApplicationInvoiceLine",
  id: string,
  amountVatExcluded: number,
  applicationInvoiceId: string,
  applicationInvoice?: ApplicationInvoiceDTO | null,
  calculationDetail?: ApplicationPlanCalculationDetail | null,
  calculationMethod?: ApplicationPlanCalculationMethod | null,
  clientId: string,
  customLabel?: string | null,
  extraInformation?: ApplicationInvoiceLineExtraInformation | null,
  quantity: number,
  periodFrom?: string | null,
  periodTo?: string | null,
  subscriptionVariousOperationId?: string | null,
  subscriptionVariousOperation?: ApplicationSubscriptionVariousOperationDTO | null,
  subscriptionUsageHistoryId?: string | null,
  subscriptionUsageHistory?: SubscriptionUsageHistoryDTO | null,
  totalAmount: number,
  type: ApplicationInvoiceLineType,
  vatAmount?: number | null,
  vatRate?: number | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export enum ApplicationInvoiceLineExtraInformation {
  PRO_RATA_LINE = "PRO_RATA_LINE",
  TRIAL_PERIOD = "TRIAL_PERIOD",
}


export type SubscriptionUsageHistoryDTO = {
  __typename: "SubscriptionUsageHistory",
  id: string,
  clientId: string,
  createdAt: string,
  creditUsageDetail?: SubscriptionCreditUsageHistoryDetail | null,
  customerCreatorId?: string | null,
  requestId?: string | null,
  applicationInvoiceId?: string | null,
  storageUsageDetail?: SubscriptionStorageUsageHistoryDetail | null,
  type: UsageType,
  unitsUsageDetail?: SubscriptionUnitsUsageHistoryDetail | null,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type SubscriptionCreditUsageHistoryDetail = {
  __typename: "SubscriptionCreditUsageHistoryDetail",
  numberUsed: number,
  creditsAccount: CreditsAccount,
  creditOperationType: CreditOperationType,
};

export enum CreditsAccount {
  PAID = "PAID",
  INCLUDED = "INCLUDED",
}


export type SubscriptionStorageUsageHistoryDetail = {
  __typename: "SubscriptionStorageUsageHistoryDetail",
  numberUsed: number,
};

export enum UsageType {
  CREDIT = "CREDIT",
  NUMBER_OF_UNITS = "NUMBER_OF_UNITS",
  STORAGE = "STORAGE",
}


export type SubscriptionUnitsUsageHistoryDetail = {
  __typename: "SubscriptionUnitsUsageHistoryDetail",
  unitsUsage:  Array<SubscriptionUnitUsageHistoryDetail >,
  proRataUnits:  Array<SubscriptionUnitProRataUsageHistoryDetail >,
};

export type SubscriptionUnitUsageHistoryDetail = {
  __typename: "SubscriptionUnitUsageHistoryDetail",
  numberUsed: number,
  unitId?: string | null,
  lastKnownLeasePrice?: number | null,
  advertisedRentalPrice?: number | null,
  type?: UnitType | null,
};

export type SubscriptionUnitProRataUsageHistoryDetail = {
  __typename: "SubscriptionUnitProRataUsageHistoryDetail",
  unitId: string,
  numberOfDays: number,
  lastKnownLeasePrice?: number | null,
  advertisedRentalPrice?: number | null,
  type?: UnitType | null,
};

export enum ApplicationInvoiceLineType {
  LICENSE = "LICENSE",
  SETUP_FEES = "SETUP_FEES",
  USAGE_CREDIT = "USAGE_CREDIT",
  USAGE_STORAGE = "USAGE_STORAGE",
  VARIOUS_OPERATION = "VARIOUS_OPERATION",
}


export type ApplicationInvoiceClientSnapshot = {
  __typename: "ApplicationInvoiceClientSnapshot",
  name: string,
  vat?: string | null,
  businessNumber?: string | null,
  email?: string | null,
  address?: ApplicationInvoiceClientSnapshotAddress | null,
};

export type ApplicationInvoiceClientSnapshotAddress = {
  __typename: "ApplicationInvoiceClientSnapshotAddress",
  street?: string | null,
  number?: string | null,
  box?: string | null,
  postalCode?: string | null,
  city?: string | null,
  country?: string | null,
};

export type ApplicationInvoicePeppolProperties = {
  __typename: "ApplicationInvoicePeppolProperties",
  peppolStatus?: InvoicePeppolStatus | null,
  peppolId?: string | null,
  peppolErrorType?: string | null,
  peppolErrorMessage?: string | null,
};

export enum InvoicePeppolStatus {
  ERROR = "ERROR",
  SENT = "SENT",
  PENDING = "PENDING",
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
}


export enum ApplicationInvoiceStatus {
  DRAFT = "DRAFT",
  NOTIFIED = "NOTIFIED",
  PAID = "PAID",
  PROCESSING = "PROCESSING",
  SENT = "SENT",
}


export type UpdateAdminCommunicationInput = {
  id: string,
  body?: string | null,
  clientId?: string | null,
  createdAt?: string | null,
  externalId?: string | null,
  applicationInvoiceId?: string | null,
  recipient?: string | null,
  sentAt?: string | null,
  status?: AdminCommunicationStatus | null,
  subject?: string | null,
  _version?: number | null,
};

export type DeleteAdminCommunicationInput = {
  id: string,
  _version?: number | null,
};

export type CreateAdminFileInput = {
  id?: string | null,
  bucket: string,
  createdAt?: string | null,
  foreignKey: string,
  foreignTableName: string,
  key: string,
  mimeType?: string | null,
  region: string,
  size?: number | null,
  clientId?: string | null,
  _version?: number | null,
};

export type ModelAdminFileConditionInput = {
  bucket?: AdminModelStringInput | null,
  createdAt?: AdminModelStringInput | null,
  foreignKey?: AdminModelIDInput | null,
  foreignTableName?: AdminModelStringInput | null,
  key?: AdminModelStringInput | null,
  mimeType?: AdminModelStringInput | null,
  region?: AdminModelStringInput | null,
  size?: AdminModelIntInput | null,
  clientId?: AdminModelIDInput | null,
  and?: Array< ModelAdminFileConditionInput | null > | null,
  or?: Array< ModelAdminFileConditionInput | null > | null,
  not?: ModelAdminFileConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type AdminFileDTO = {
  __typename: "AdminFile",
  id: string,
  bucket: string,
  createdAt: string,
  foreignKey: string,
  foreignTableName: string,
  key: string,
  mimeType?: string | null,
  region: string,
  size?: number | null,
  clientId?: string | null,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAdminFileInput = {
  id: string,
  bucket?: string | null,
  createdAt?: string | null,
  foreignKey?: string | null,
  foreignTableName?: string | null,
  key?: string | null,
  mimeType?: string | null,
  region?: string | null,
  size?: number | null,
  clientId?: string | null,
  _version?: number | null,
};

export type DeleteAdminFileInput = {
  id: string,
  _version?: number | null,
};

export type CreateApplicationInvoiceInput = {
  id?: string | null,
  amount: number,
  applicationSubscriptionId: string,
  clientId: string,
  createdAt?: string | null,
  dueDate?: string | null,
  invoiceDate: string,
  invoiceNumber?: string | null,
  periodFrom: string,
  periodTo: string,
  clientSnapshot?: ApplicationInvoiceClientSnapshotInput | null,
  peppolProperties?: ApplicationInvoicePeppolPropertiesInput | null,
  status: ApplicationInvoiceStatus,
  type: ApplicationInvoiceType,
  _version?: number | null,
};

export type ApplicationInvoiceClientSnapshotInput = {
  name: string,
  vat?: string | null,
  businessNumber?: string | null,
  email?: string | null,
  address?: ApplicationInvoiceClientSnapshotAddressInput | null,
};

export type ApplicationInvoiceClientSnapshotAddressInput = {
  street?: string | null,
  number?: string | null,
  box?: string | null,
  postalCode?: string | null,
  city?: string | null,
  country?: string | null,
};

export type ApplicationInvoicePeppolPropertiesInput = {
  peppolStatus?: InvoicePeppolStatus | null,
  peppolId?: string | null,
  peppolErrorType?: string | null,
  peppolErrorMessage?: string | null,
};

export type ModelApplicationInvoiceConditionInput = {
  amount?: AdminModelFloatInput | null,
  applicationSubscriptionId?: AdminModelIDInput | null,
  clientId?: AdminModelIDInput | null,
  createdAt?: AdminModelStringInput | null,
  dueDate?: AdminModelStringInput | null,
  invoiceDate?: AdminModelStringInput | null,
  invoiceNumber?: AdminModelStringInput | null,
  periodFrom?: AdminModelStringInput | null,
  periodTo?: AdminModelStringInput | null,
  status?: ModelApplicationInvoiceStatusInput | null,
  type?: ModelApplicationInvoiceTypeInput | null,
  and?: Array< ModelApplicationInvoiceConditionInput | null > | null,
  or?: Array< ModelApplicationInvoiceConditionInput | null > | null,
  not?: ModelApplicationInvoiceConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type AdminModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: AdminModelAttributeTypes | null,
};

export type ModelApplicationInvoiceStatusInput = {
  eq?: ApplicationInvoiceStatus | null,
  ne?: ApplicationInvoiceStatus | null,
};

export type UpdateApplicationInvoiceInput = {
  id: string,
  amount?: number | null,
  applicationSubscriptionId?: string | null,
  clientId?: string | null,
  createdAt?: string | null,
  dueDate?: string | null,
  invoiceDate?: string | null,
  invoiceNumber?: string | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  clientSnapshot?: ApplicationInvoiceClientSnapshotInput | null,
  peppolProperties?: ApplicationInvoicePeppolPropertiesInput | null,
  status?: ApplicationInvoiceStatus | null,
  type?: ApplicationInvoiceType | null,
  _version?: number | null,
};

export type DeleteApplicationInvoiceInput = {
  id: string,
  _version?: number | null,
};

export type CreateApplicationInvoiceLineInput = {
  id?: string | null,
  amountVatExcluded: number,
  applicationInvoiceId: string,
  calculationDetail?: ApplicationPlanCalculationDetailInput | null,
  calculationMethod?: ApplicationPlanCalculationMethod | null,
  clientId: string,
  customLabel?: string | null,
  extraInformation?: ApplicationInvoiceLineExtraInformation | null,
  quantity: number,
  periodFrom?: string | null,
  periodTo?: string | null,
  subscriptionVariousOperationId?: string | null,
  subscriptionUsageHistoryId?: string | null,
  totalAmount: number,
  type: ApplicationInvoiceLineType,
  vatAmount?: number | null,
  vatRate?: number | null,
  _version?: number | null,
};

export type ApplicationPlanCalculationDetailInput = {
  amountType: ApplicationPlanCalculationAmountDetailType,
  endNumber?: number | null,
  feeApplied: number,
  minimumFixedUnitPriceThreshold?: number | null,
  startNumber: number,
  unitType: Array< UnitType >,
};

export type ModelApplicationInvoiceLineConditionInput = {
  amountVatExcluded?: AdminModelFloatInput | null,
  applicationInvoiceId?: AdminModelIDInput | null,
  calculationMethod?: ModelApplicationPlanCalculationMethodInput | null,
  clientId?: AdminModelIDInput | null,
  customLabel?: AdminModelStringInput | null,
  extraInformation?: ModelApplicationInvoiceLineExtraInformationInput | null,
  quantity?: AdminModelFloatInput | null,
  periodFrom?: AdminModelStringInput | null,
  periodTo?: AdminModelStringInput | null,
  subscriptionVariousOperationId?: AdminModelIDInput | null,
  subscriptionUsageHistoryId?: AdminModelIDInput | null,
  totalAmount?: AdminModelFloatInput | null,
  type?: ModelApplicationInvoiceLineTypeInput | null,
  vatAmount?: AdminModelFloatInput | null,
  vatRate?: AdminModelFloatInput | null,
  and?: Array< ModelApplicationInvoiceLineConditionInput | null > | null,
  or?: Array< ModelApplicationInvoiceLineConditionInput | null > | null,
  not?: ModelApplicationInvoiceLineConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type ModelApplicationPlanCalculationMethodInput = {
  eq?: ApplicationPlanCalculationMethod | null,
  ne?: ApplicationPlanCalculationMethod | null,
};

export type ModelApplicationInvoiceLineExtraInformationInput = {
  eq?: ApplicationInvoiceLineExtraInformation | null,
  ne?: ApplicationInvoiceLineExtraInformation | null,
};

export type ModelApplicationInvoiceLineTypeInput = {
  eq?: ApplicationInvoiceLineType | null,
  ne?: ApplicationInvoiceLineType | null,
};

export type UpdateApplicationInvoiceLineInput = {
  id: string,
  amountVatExcluded?: number | null,
  applicationInvoiceId?: string | null,
  calculationDetail?: ApplicationPlanCalculationDetailInput | null,
  calculationMethod?: ApplicationPlanCalculationMethod | null,
  clientId?: string | null,
  customLabel?: string | null,
  extraInformation?: ApplicationInvoiceLineExtraInformation | null,
  quantity?: number | null,
  periodFrom?: string | null,
  periodTo?: string | null,
  subscriptionVariousOperationId?: string | null,
  subscriptionUsageHistoryId?: string | null,
  totalAmount?: number | null,
  type?: ApplicationInvoiceLineType | null,
  vatAmount?: number | null,
  vatRate?: number | null,
  _version?: number | null,
};

export type DeleteApplicationInvoiceLineInput = {
  id: string,
  _version?: number | null,
};

export type CreateApplicationPlanInput = {
  id?: string | null,
  calculationDetails: Array< ApplicationPlanCalculationDetailInput >,
  calculationMethod: ApplicationPlanCalculationMethod,
  isBillable: boolean,
  isDefaultPlan: boolean,
  labels: Array< LabelInput >,
  numberOfTrialMonths: number,
  setupFees: number,
  _version?: number | null,
};

export type LabelInput = {
  language: Language,
  label: string,
};

export type ModelApplicationPlanConditionInput = {
  calculationMethod?: ModelApplicationPlanCalculationMethodInput | null,
  isBillable?: AdminModelBooleanInput | null,
  isDefaultPlan?: AdminModelBooleanInput | null,
  numberOfTrialMonths?: AdminModelIntInput | null,
  setupFees?: AdminModelFloatInput | null,
  and?: Array< ModelApplicationPlanConditionInput | null > | null,
  or?: Array< ModelApplicationPlanConditionInput | null > | null,
  not?: ModelApplicationPlanConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type UpdateApplicationPlanInput = {
  id: string,
  calculationDetails?: Array< ApplicationPlanCalculationDetailInput > | null,
  calculationMethod?: ApplicationPlanCalculationMethod | null,
  isBillable?: boolean | null,
  isDefaultPlan?: boolean | null,
  labels?: Array< LabelInput > | null,
  numberOfTrialMonths?: number | null,
  setupFees?: number | null,
  _version?: number | null,
};

export type DeleteApplicationPlanInput = {
  id: string,
  _version?: number | null,
};

export type CreateApplicationSubscriptionInput = {
  id?: string | null,
  clientId: string,
  creditsBalancePaid: number,
  creditsBalanceIncluded: number,
  creditsConfiguration: CreditsConfigurationInput,
  endDate?: string | null,
  language: Language,
  lastInvoiceDate?: string | null,
  paymentCustomerId?: string | null,
  paymentLastExecution?: string | null,
  paymentLastStatus: PaymentStatus,
  paymentLastError?: string | null,
  paymentMethodId?: string | null,
  paymentMode: PaymentMode,
  paymentTerms: PaymentTerms,
  invoicesProperties?: InvoicesPropertiesInput | null,
  planId: string,
  referenceNumber?: string | null,
  sellerId?: string | null,
  startDate: string,
  status: ApplicationSubscriptionStatus,
  _version?: number | null,
};

export type CreditsConfigurationInput = {
  allowPostPaid: boolean,
  creditsNotification: Array< CustomerNotification >,
  postPaidThreshold: number,
};

export type InvoicesPropertiesInput = {
  hideQuantities?: boolean | null,
};

export type ModelApplicationSubscriptionConditionInput = {
  clientId?: AdminModelIDInput | null,
  creditsBalancePaid?: AdminModelFloatInput | null,
  creditsBalanceIncluded?: AdminModelFloatInput | null,
  endDate?: AdminModelStringInput | null,
  language?: AdminModelLanguageInput | null,
  lastInvoiceDate?: AdminModelStringInput | null,
  paymentCustomerId?: AdminModelIDInput | null,
  paymentLastExecution?: AdminModelStringInput | null,
  paymentLastStatus?: ModelPaymentStatusInput | null,
  paymentLastError?: AdminModelStringInput | null,
  paymentMethodId?: AdminModelIDInput | null,
  paymentMode?: ModelPaymentModeInput | null,
  paymentTerms?: ModelPaymentTermsInput | null,
  planId?: AdminModelIDInput | null,
  referenceNumber?: AdminModelStringInput | null,
  sellerId?: AdminModelIDInput | null,
  startDate?: AdminModelStringInput | null,
  status?: ModelApplicationSubscriptionStatusInput | null,
  and?: Array< ModelApplicationSubscriptionConditionInput | null > | null,
  or?: Array< ModelApplicationSubscriptionConditionInput | null > | null,
  not?: ModelApplicationSubscriptionConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type AdminModelLanguageInput = {
  eq?: Language | null,
  ne?: Language | null,
};

export type ModelPaymentStatusInput = {
  eq?: PaymentStatus | null,
  ne?: PaymentStatus | null,
};

export type ModelPaymentModeInput = {
  eq?: PaymentMode | null,
  ne?: PaymentMode | null,
};

export type ModelPaymentTermsInput = {
  eq?: PaymentTerms | null,
  ne?: PaymentTerms | null,
};

export type ModelApplicationSubscriptionStatusInput = {
  eq?: ApplicationSubscriptionStatus | null,
  ne?: ApplicationSubscriptionStatus | null,
};

export type UpdateApplicationSubscriptionInput = {
  id: string,
  clientId?: string | null,
  creditsBalancePaid?: number | null,
  creditsBalanceIncluded?: number | null,
  creditsConfiguration?: CreditsConfigurationInput | null,
  endDate?: string | null,
  language?: Language | null,
  lastInvoiceDate?: string | null,
  paymentCustomerId?: string | null,
  paymentLastExecution?: string | null,
  paymentLastStatus?: PaymentStatus | null,
  paymentLastError?: string | null,
  paymentMethodId?: string | null,
  paymentMode?: PaymentMode | null,
  paymentTerms?: PaymentTerms | null,
  invoicesProperties?: InvoicesPropertiesInput | null,
  planId?: string | null,
  referenceNumber?: string | null,
  sellerId?: string | null,
  startDate?: string | null,
  status?: ApplicationSubscriptionStatus | null,
  _version?: number | null,
};

export type DeleteApplicationSubscriptionInput = {
  id: string,
  _version?: number | null,
};

export type CreateApplicationSubscriptionVariousOperationInput = {
  id?: string | null,
  applicationSubscriptionId: string,
  clientId: string,
  createdAt?: string | null,
  endDate?: string | null,
  label: string,
  lastInvoiceDate?: string | null,
  sellerId: string,
  startDate: string,
  subscriptionVariousOperationHistories: Array< SubscriptionVariousOperationHistoryInput >,
  type: ApplicationVariousOperationType,
  _version?: number | null,
};

export type SubscriptionVariousOperationHistoryInput = {
  periodFrom: string,
  periodTo?: string | null,
  amount: number,
};

export type ModelApplicationSubscriptionVariousOperationConditionInput = {
  applicationSubscriptionId?: AdminModelIDInput | null,
  clientId?: AdminModelIDInput | null,
  createdAt?: AdminModelStringInput | null,
  endDate?: AdminModelStringInput | null,
  label?: AdminModelStringInput | null,
  lastInvoiceDate?: AdminModelStringInput | null,
  sellerId?: AdminModelIDInput | null,
  startDate?: AdminModelStringInput | null,
  type?: ModelApplicationVariousOperationTypeInput | null,
  and?: Array< ModelApplicationSubscriptionVariousOperationConditionInput | null > | null,
  or?: Array< ModelApplicationSubscriptionVariousOperationConditionInput | null > | null,
  not?: ModelApplicationSubscriptionVariousOperationConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type ModelApplicationVariousOperationTypeInput = {
  eq?: ApplicationVariousOperationType | null,
  ne?: ApplicationVariousOperationType | null,
};

export type UpdateApplicationSubscriptionVariousOperationInput = {
  id: string,
  applicationSubscriptionId?: string | null,
  clientId?: string | null,
  createdAt?: string | null,
  endDate?: string | null,
  label?: string | null,
  lastInvoiceDate?: string | null,
  sellerId?: string | null,
  startDate?: string | null,
  subscriptionVariousOperationHistories?: Array< SubscriptionVariousOperationHistoryInput > | null,
  type?: ApplicationVariousOperationType | null,
  _version?: number | null,
};

export type DeleteApplicationSubscriptionVariousOperationInput = {
  id: string,
  _version?: number | null,
};

export type CreateApplicationVariousOperationInput = {
  id?: string | null,
  amount: number,
  customerVisible: boolean,
  duration: ApplicationVariousOperationDuration,
  labels: Array< LabelInput >,
  numberOfCredits?: number | null,
  type: ApplicationVariousOperationType,
  _version?: number | null,
  applicationPlanIncludedVariousOperationsId: string,
};

export type ModelApplicationVariousOperationConditionInput = {
  amount?: AdminModelFloatInput | null,
  customerVisible?: AdminModelBooleanInput | null,
  duration?: ModelApplicationVariousOperationDurationInput | null,
  numberOfCredits?: AdminModelFloatInput | null,
  type?: ModelApplicationVariousOperationTypeInput | null,
  and?: Array< ModelApplicationVariousOperationConditionInput | null > | null,
  or?: Array< ModelApplicationVariousOperationConditionInput | null > | null,
  not?: ModelApplicationVariousOperationConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
  applicationPlanIncludedVariousOperationsId?: AdminModelIDInput | null,
};

export type ModelApplicationVariousOperationDurationInput = {
  eq?: ApplicationVariousOperationDuration | null,
  ne?: ApplicationVariousOperationDuration | null,
};

export type UpdateApplicationVariousOperationInput = {
  id: string,
  amount?: number | null,
  customerVisible?: boolean | null,
  duration?: ApplicationVariousOperationDuration | null,
  labels?: Array< LabelInput > | null,
  numberOfCredits?: number | null,
  type?: ApplicationVariousOperationType | null,
  _version?: number | null,
  applicationPlanIncludedVariousOperationsId?: string | null,
};

export type DeleteApplicationVariousOperationInput = {
  id: string,
  _version?: number | null,
};

export type CreateCompanyUserInput = {
  id?: string | null,
  cognitoSub?: string | null,
  email: string,
  firstName: string,
  language?: Language | null,
  lastName: string,
  _version?: number | null,
};

export type ModelCompanyUserConditionInput = {
  cognitoSub?: AdminModelIDInput | null,
  email?: AdminModelStringInput | null,
  firstName?: AdminModelStringInput | null,
  language?: AdminModelLanguageInput | null,
  lastName?: AdminModelStringInput | null,
  and?: Array< ModelCompanyUserConditionInput | null > | null,
  or?: Array< ModelCompanyUserConditionInput | null > | null,
  not?: ModelCompanyUserConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type UpdateCompanyUserInput = {
  id: string,
  cognitoSub?: string | null,
  email?: string | null,
  firstName?: string | null,
  language?: Language | null,
  lastName?: string | null,
  _version?: number | null,
};

export type DeleteCompanyUserInput = {
  id: string,
  _version?: number | null,
};

export type CreateCreditCostInput = {
  id?: string | null,
  clientId?: string | null,
  endDate?: string | null,
  numberOfCredits: number,
  price: number,
  startDate: string,
  _version?: number | null,
};

export type ModelCreditCostConditionInput = {
  clientId?: AdminModelIDInput | null,
  endDate?: AdminModelStringInput | null,
  numberOfCredits?: AdminModelFloatInput | null,
  price?: AdminModelFloatInput | null,
  startDate?: AdminModelStringInput | null,
  and?: Array< ModelCreditCostConditionInput | null > | null,
  or?: Array< ModelCreditCostConditionInput | null > | null,
  not?: ModelCreditCostConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type CreditCostDTO = {
  __typename: "CreditCost",
  id: string,
  clientId?: string | null,
  endDate?: string | null,
  numberOfCredits: number,
  price: number,
  startDate: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateCreditCostInput = {
  id: string,
  clientId?: string | null,
  endDate?: string | null,
  numberOfCredits?: number | null,
  price?: number | null,
  startDate?: string | null,
  _version?: number | null,
};

export type DeleteCreditCostInput = {
  id: string,
  _version?: number | null,
};

export type CreateCreditUsageCostInput = {
  id?: string | null,
  endDate?: string | null,
  numberOfCreditsPerOperation: number,
  startDate: string,
  type: CreditOperationType,
  _version?: number | null,
};

export type ModelCreditUsageCostConditionInput = {
  endDate?: AdminModelStringInput | null,
  numberOfCreditsPerOperation?: AdminModelFloatInput | null,
  startDate?: AdminModelStringInput | null,
  type?: ModelCreditOperationTypeInput | null,
  and?: Array< ModelCreditUsageCostConditionInput | null > | null,
  or?: Array< ModelCreditUsageCostConditionInput | null > | null,
  not?: ModelCreditUsageCostConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type ModelCreditOperationTypeInput = {
  eq?: CreditOperationType | null,
  ne?: CreditOperationType | null,
};

export type CreditUsageCostDTO = {
  __typename: "CreditUsageCost",
  id: string,
  endDate?: string | null,
  numberOfCreditsPerOperation: number,
  startDate: string,
  type: CreditOperationType,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateCreditUsageCostInput = {
  id: string,
  endDate?: string | null,
  numberOfCreditsPerOperation?: number | null,
  startDate?: string | null,
  type?: CreditOperationType | null,
  _version?: number | null,
};

export type DeleteCreditUsageCostInput = {
  id: string,
  _version?: number | null,
};

export type CreateSubscriptionUsageHistoryInput = {
  id?: string | null,
  clientId: string,
  createdAt?: string | null,
  creditUsageDetail?: SubscriptionCreditUsageHistoryDetailInput | null,
  customerCreatorId?: string | null,
  requestId?: string | null,
  applicationInvoiceId?: string | null,
  storageUsageDetail?: SubscriptionStorageUsageHistoryDetailInput | null,
  type: UsageType,
  unitsUsageDetail?: SubscriptionUnitsUsageHistoryDetailInput | null,
  _version?: number | null,
};

export type SubscriptionCreditUsageHistoryDetailInput = {
  numberUsed: number,
  creditsAccount: CreditsAccount,
  creditOperationType: CreditOperationType,
};

export type SubscriptionStorageUsageHistoryDetailInput = {
  numberUsed: number,
};

export type SubscriptionUnitsUsageHistoryDetailInput = {
  unitsUsage: Array< SubscriptionUnitUsageHistoryDetailInput >,
  proRataUnits: Array< SubscriptionUnitProRataUsageHistoryDetailInput >,
};

export type SubscriptionUnitUsageHistoryDetailInput = {
  numberUsed: number,
  unitId?: string | null,
  lastKnownLeasePrice?: number | null,
  advertisedRentalPrice?: number | null,
  type?: UnitType | null,
};

export type SubscriptionUnitProRataUsageHistoryDetailInput = {
  unitId: string,
  numberOfDays: number,
  lastKnownLeasePrice?: number | null,
  advertisedRentalPrice?: number | null,
  type?: UnitType | null,
};

export type ModelSubscriptionUsageHistoryConditionInput = {
  clientId?: AdminModelIDInput | null,
  createdAt?: AdminModelStringInput | null,
  customerCreatorId?: AdminModelIDInput | null,
  requestId?: AdminModelIDInput | null,
  applicationInvoiceId?: AdminModelIDInput | null,
  type?: ModelUsageTypeInput | null,
  and?: Array< ModelSubscriptionUsageHistoryConditionInput | null > | null,
  or?: Array< ModelSubscriptionUsageHistoryConditionInput | null > | null,
  not?: ModelSubscriptionUsageHistoryConditionInput | null,
  _deleted?: AdminModelBooleanInput | null,
  updatedAt?: AdminModelStringInput | null,
};

export type ModelUsageTypeInput = {
  eq?: UsageType | null,
  ne?: UsageType | null,
};

export type UpdateSubscriptionUsageHistoryInput = {
  id: string,
  clientId?: string | null,
  createdAt?: string | null,
  creditUsageDetail?: SubscriptionCreditUsageHistoryDetailInput | null,
  customerCreatorId?: string | null,
  requestId?: string | null,
  applicationInvoiceId?: string | null,
  storageUsageDetail?: SubscriptionStorageUsageHistoryDetailInput | null,
  type?: UsageType | null,
  unitsUsageDetail?: SubscriptionUnitsUsageHistoryDetailInput | null,
  _version?: number | null,
};

export type DeleteSubscriptionUsageHistoryInput = {
  id: string,
  _version?: number | null,
};

export type CheckAndConsumeCreditsInput = {
  chargeOncePerRequest?: boolean | null,
  clientId: string,
  numberOfOperations: number,
  requestId?: string | null,
  type: CreditOperationType,
  userId?: string | null,
};

export type CheckAndConsumeCreditsResponse = {
  __typename: "CheckAndConsumeCreditsResponse",
  creditsBalance: number,
  creditsNeeded: number,
  creditsUsed: number,
  status: CheckAndConsumeCreditsResponseStatus,
};

export enum CheckAndConsumeCreditsResponseStatus {
  CONSUMED = "CONSUMED",
  NOT_ENOUGH_CREDITS = "NOT_ENOUGH_CREDITS",
  ERROR = "ERROR",
}


export type DisableClientAccountInput = {
  clientId: string,
  timestamp?: number | null,
  reactivation?: boolean | null,
  reauthToken?: string | null,
};

export type DisableClientAccountResponse = {
  __typename: "DisableClientAccountResponse",
  deletionTime: string,
  success: boolean,
  errorMessage?: string | null,
};

export type ModelDocumentNumberFilterInput = {
  id?: AdminModelIDInput | null,
  format?: AdminModelStringInput | null,
  lastUpdate?: AdminModelStringInput | null,
  incrementNumber?: AdminModelIntInput | null,
  type?: ModelApplicationInvoiceTypeInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelDocumentNumberFilterInput | null > | null,
  or?: Array< ModelDocumentNumberFilterInput | null > | null,
  not?: ModelDocumentNumberFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelDocumentNumberConnection = {
  __typename: "ModelDocumentNumberConnection",
  items:  Array<DocumentNumberDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAdminCommunicationFilterInput = {
  id?: AdminModelIDInput | null,
  body?: AdminModelStringInput | null,
  clientId?: AdminModelIDInput | null,
  createdAt?: AdminModelStringInput | null,
  externalId?: AdminModelIDInput | null,
  applicationInvoiceId?: AdminModelIDInput | null,
  recipient?: AdminModelStringInput | null,
  sentAt?: AdminModelStringInput | null,
  status?: ModelAdminCommunicationStatusInput | null,
  subject?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelAdminCommunicationFilterInput | null > | null,
  or?: Array< ModelAdminCommunicationFilterInput | null > | null,
  not?: ModelAdminCommunicationFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelAdminCommunicationConnection = {
  __typename: "ModelAdminCommunicationConnection",
  items:  Array<AdminCommunicationDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type AdminModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export enum AdminModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelAdminFileFilterInput = {
  id?: AdminModelIDInput | null,
  bucket?: AdminModelStringInput | null,
  createdAt?: AdminModelStringInput | null,
  foreignKey?: AdminModelIDInput | null,
  foreignTableName?: AdminModelStringInput | null,
  key?: AdminModelStringInput | null,
  mimeType?: AdminModelStringInput | null,
  region?: AdminModelStringInput | null,
  size?: AdminModelIntInput | null,
  clientId?: AdminModelIDInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelAdminFileFilterInput | null > | null,
  or?: Array< ModelAdminFileFilterInput | null > | null,
  not?: ModelAdminFileFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelAdminFileConnection = {
  __typename: "ModelAdminFileConnection",
  items:  Array<AdminFileDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelApplicationInvoiceFilterInput = {
  id?: AdminModelIDInput | null,
  amount?: AdminModelFloatInput | null,
  applicationSubscriptionId?: AdminModelIDInput | null,
  clientId?: AdminModelIDInput | null,
  createdAt?: AdminModelStringInput | null,
  dueDate?: AdminModelStringInput | null,
  invoiceDate?: AdminModelStringInput | null,
  invoiceNumber?: AdminModelStringInput | null,
  periodFrom?: AdminModelStringInput | null,
  periodTo?: AdminModelStringInput | null,
  status?: ModelApplicationInvoiceStatusInput | null,
  type?: ModelApplicationInvoiceTypeInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelApplicationInvoiceFilterInput | null > | null,
  or?: Array< ModelApplicationInvoiceFilterInput | null > | null,
  not?: ModelApplicationInvoiceFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelApplicationInvoiceConnection = {
  __typename: "ModelApplicationInvoiceConnection",
  items:  Array<ApplicationInvoiceDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelApplicationInvoiceLineFilterInput = {
  id?: AdminModelIDInput | null,
  amountVatExcluded?: AdminModelFloatInput | null,
  applicationInvoiceId?: AdminModelIDInput | null,
  calculationMethod?: ModelApplicationPlanCalculationMethodInput | null,
  clientId?: AdminModelIDInput | null,
  customLabel?: AdminModelStringInput | null,
  extraInformation?: ModelApplicationInvoiceLineExtraInformationInput | null,
  quantity?: AdminModelFloatInput | null,
  periodFrom?: AdminModelStringInput | null,
  periodTo?: AdminModelStringInput | null,
  subscriptionVariousOperationId?: AdminModelIDInput | null,
  subscriptionUsageHistoryId?: AdminModelIDInput | null,
  totalAmount?: AdminModelFloatInput | null,
  type?: ModelApplicationInvoiceLineTypeInput | null,
  vatAmount?: AdminModelFloatInput | null,
  vatRate?: AdminModelFloatInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelApplicationInvoiceLineFilterInput | null > | null,
  or?: Array< ModelApplicationInvoiceLineFilterInput | null > | null,
  not?: ModelApplicationInvoiceLineFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelApplicationPlanFilterInput = {
  id?: AdminModelIDInput | null,
  calculationMethod?: ModelApplicationPlanCalculationMethodInput | null,
  isBillable?: AdminModelBooleanInput | null,
  isDefaultPlan?: AdminModelBooleanInput | null,
  numberOfTrialMonths?: AdminModelIntInput | null,
  setupFees?: AdminModelFloatInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelApplicationPlanFilterInput | null > | null,
  or?: Array< ModelApplicationPlanFilterInput | null > | null,
  not?: ModelApplicationPlanFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelApplicationPlanConnection = {
  __typename: "ModelApplicationPlanConnection",
  items:  Array<ApplicationPlanDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelApplicationSubscriptionFilterInput = {
  id?: AdminModelIDInput | null,
  clientId?: AdminModelIDInput | null,
  creditsBalancePaid?: AdminModelFloatInput | null,
  creditsBalanceIncluded?: AdminModelFloatInput | null,
  endDate?: AdminModelStringInput | null,
  language?: AdminModelLanguageInput | null,
  lastInvoiceDate?: AdminModelStringInput | null,
  paymentCustomerId?: AdminModelIDInput | null,
  paymentLastExecution?: AdminModelStringInput | null,
  paymentLastStatus?: ModelPaymentStatusInput | null,
  paymentLastError?: AdminModelStringInput | null,
  paymentMethodId?: AdminModelIDInput | null,
  paymentMode?: ModelPaymentModeInput | null,
  paymentTerms?: ModelPaymentTermsInput | null,
  planId?: AdminModelIDInput | null,
  referenceNumber?: AdminModelStringInput | null,
  sellerId?: AdminModelIDInput | null,
  startDate?: AdminModelStringInput | null,
  status?: ModelApplicationSubscriptionStatusInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelApplicationSubscriptionFilterInput | null > | null,
  or?: Array< ModelApplicationSubscriptionFilterInput | null > | null,
  not?: ModelApplicationSubscriptionFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelApplicationSubscriptionConnection = {
  __typename: "ModelApplicationSubscriptionConnection",
  items:  Array<ApplicationSubscriptionDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelApplicationSubscriptionVariousOperationFilterInput = {
  id?: AdminModelIDInput | null,
  applicationSubscriptionId?: AdminModelIDInput | null,
  clientId?: AdminModelIDInput | null,
  createdAt?: AdminModelStringInput | null,
  endDate?: AdminModelStringInput | null,
  label?: AdminModelStringInput | null,
  lastInvoiceDate?: AdminModelStringInput | null,
  sellerId?: AdminModelIDInput | null,
  startDate?: AdminModelStringInput | null,
  type?: ModelApplicationVariousOperationTypeInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelApplicationSubscriptionVariousOperationFilterInput | null > | null,
  or?: Array< ModelApplicationSubscriptionVariousOperationFilterInput | null > | null,
  not?: ModelApplicationSubscriptionVariousOperationFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelApplicationVariousOperationFilterInput = {
  id?: AdminModelIDInput | null,
  amount?: AdminModelFloatInput | null,
  customerVisible?: AdminModelBooleanInput | null,
  duration?: ModelApplicationVariousOperationDurationInput | null,
  numberOfCredits?: AdminModelFloatInput | null,
  type?: ModelApplicationVariousOperationTypeInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelApplicationVariousOperationFilterInput | null > | null,
  or?: Array< ModelApplicationVariousOperationFilterInput | null > | null,
  not?: ModelApplicationVariousOperationFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
  applicationPlanIncludedVariousOperationsId?: AdminModelIDInput | null,
};

export type ModelCompanyUserFilterInput = {
  id?: AdminModelIDInput | null,
  cognitoSub?: AdminModelIDInput | null,
  email?: AdminModelStringInput | null,
  firstName?: AdminModelStringInput | null,
  language?: AdminModelLanguageInput | null,
  lastName?: AdminModelStringInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelCompanyUserFilterInput | null > | null,
  or?: Array< ModelCompanyUserFilterInput | null > | null,
  not?: ModelCompanyUserFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelCompanyUserConnection = {
  __typename: "ModelCompanyUserConnection",
  items:  Array<CompanyUserDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelCreditCostFilterInput = {
  clientId: string,
};

export type ModelCreditCostConnection = {
  __typename: "ModelCreditCostConnection",
  items:  Array<CreditCostDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelCreditUsageCostFilterInput = {
  id?: AdminModelIDInput | null,
  endDate?: AdminModelStringInput | null,
  numberOfCreditsPerOperation?: AdminModelFloatInput | null,
  startDate?: AdminModelStringInput | null,
  type?: ModelCreditOperationTypeInput | null,
  createdAt?: AdminModelStringInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelCreditUsageCostFilterInput | null > | null,
  or?: Array< ModelCreditUsageCostFilterInput | null > | null,
  not?: ModelCreditUsageCostFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelCreditUsageCostConnection = {
  __typename: "ModelCreditUsageCostConnection",
  items:  Array<CreditUsageCostDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSubscriptionUsageHistoryFilterInput = {
  id?: AdminModelIDInput | null,
  clientId?: AdminModelIDInput | null,
  createdAt?: AdminModelStringInput | null,
  customerCreatorId?: AdminModelIDInput | null,
  requestId?: AdminModelIDInput | null,
  applicationInvoiceId?: AdminModelIDInput | null,
  type?: ModelUsageTypeInput | null,
  updatedAt?: AdminModelStringInput | null,
  and?: Array< ModelSubscriptionUsageHistoryFilterInput | null > | null,
  or?: Array< ModelSubscriptionUsageHistoryFilterInput | null > | null,
  not?: ModelSubscriptionUsageHistoryFilterInput | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelSubscriptionUsageHistoryConnection = {
  __typename: "ModelSubscriptionUsageHistoryConnection",
  items:  Array<SubscriptionUsageHistoryDTO | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSubscriptionDocumentNumberFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  format?: AdminModelSubscriptionStringInput | null,
  lastUpdate?: AdminModelSubscriptionStringInput | null,
  incrementNumber?: AdminModelSubscriptionIntInput | null,
  type?: AdminModelSubscriptionStringInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDocumentNumberFilterInput | null > | null,
  or?: Array< ModelSubscriptionDocumentNumberFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type AdminModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type AdminModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type AdminModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionAdminCommunicationFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  body?: AdminModelSubscriptionStringInput | null,
  clientId?: AdminModelSubscriptionIDInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  externalId?: AdminModelSubscriptionIDInput | null,
  applicationInvoiceId?: AdminModelSubscriptionIDInput | null,
  recipient?: AdminModelSubscriptionStringInput | null,
  sentAt?: AdminModelSubscriptionStringInput | null,
  status?: AdminModelSubscriptionStringInput | null,
  subject?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAdminCommunicationFilterInput | null > | null,
  or?: Array< ModelSubscriptionAdminCommunicationFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelSubscriptionAdminFileFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  bucket?: AdminModelSubscriptionStringInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  foreignKey?: AdminModelSubscriptionIDInput | null,
  foreignTableName?: AdminModelSubscriptionStringInput | null,
  key?: AdminModelSubscriptionStringInput | null,
  mimeType?: AdminModelSubscriptionStringInput | null,
  region?: AdminModelSubscriptionStringInput | null,
  size?: AdminModelSubscriptionIntInput | null,
  clientId?: AdminModelSubscriptionIDInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAdminFileFilterInput | null > | null,
  or?: Array< ModelSubscriptionAdminFileFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelSubscriptionApplicationInvoiceFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  amount?: AdminModelSubscriptionFloatInput | null,
  applicationSubscriptionId?: AdminModelSubscriptionIDInput | null,
  clientId?: AdminModelSubscriptionIDInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  dueDate?: AdminModelSubscriptionStringInput | null,
  invoiceDate?: AdminModelSubscriptionStringInput | null,
  invoiceNumber?: AdminModelSubscriptionStringInput | null,
  periodFrom?: AdminModelSubscriptionStringInput | null,
  periodTo?: AdminModelSubscriptionStringInput | null,
  status?: AdminModelSubscriptionStringInput | null,
  type?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionApplicationInvoiceFilterInput | null > | null,
  or?: Array< ModelSubscriptionApplicationInvoiceFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type AdminModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionApplicationInvoiceLineFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  amountVatExcluded?: AdminModelSubscriptionFloatInput | null,
  applicationInvoiceId?: AdminModelSubscriptionIDInput | null,
  calculationMethod?: AdminModelSubscriptionStringInput | null,
  clientId?: AdminModelSubscriptionIDInput | null,
  customLabel?: AdminModelSubscriptionStringInput | null,
  extraInformation?: AdminModelSubscriptionStringInput | null,
  quantity?: AdminModelSubscriptionFloatInput | null,
  periodFrom?: AdminModelSubscriptionStringInput | null,
  periodTo?: AdminModelSubscriptionStringInput | null,
  subscriptionVariousOperationId?: AdminModelSubscriptionIDInput | null,
  subscriptionUsageHistoryId?: AdminModelSubscriptionIDInput | null,
  totalAmount?: AdminModelSubscriptionFloatInput | null,
  type?: AdminModelSubscriptionStringInput | null,
  vatAmount?: AdminModelSubscriptionFloatInput | null,
  vatRate?: AdminModelSubscriptionFloatInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionApplicationInvoiceLineFilterInput | null > | null,
  or?: Array< ModelSubscriptionApplicationInvoiceLineFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelSubscriptionApplicationPlanFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  calculationMethod?: AdminModelSubscriptionStringInput | null,
  isBillable?: AdminModelSubscriptionBooleanInput | null,
  isDefaultPlan?: AdminModelSubscriptionBooleanInput | null,
  numberOfTrialMonths?: AdminModelSubscriptionIntInput | null,
  setupFees?: AdminModelSubscriptionFloatInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionApplicationPlanFilterInput | null > | null,
  or?: Array< ModelSubscriptionApplicationPlanFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
  applicationPlanIncludedVariousOperationsId?: AdminModelSubscriptionIDInput | null,
};

export type AdminModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionApplicationSubscriptionFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  clientId?: AdminModelSubscriptionIDInput | null,
  creditsBalancePaid?: AdminModelSubscriptionFloatInput | null,
  creditsBalanceIncluded?: AdminModelSubscriptionFloatInput | null,
  endDate?: AdminModelSubscriptionStringInput | null,
  language?: AdminModelSubscriptionStringInput | null,
  lastInvoiceDate?: AdminModelSubscriptionStringInput | null,
  paymentCustomerId?: AdminModelSubscriptionIDInput | null,
  paymentLastExecution?: AdminModelSubscriptionStringInput | null,
  paymentLastStatus?: AdminModelSubscriptionStringInput | null,
  paymentLastError?: AdminModelSubscriptionStringInput | null,
  paymentMethodId?: AdminModelSubscriptionIDInput | null,
  paymentMode?: AdminModelSubscriptionStringInput | null,
  paymentTerms?: AdminModelSubscriptionStringInput | null,
  planId?: AdminModelSubscriptionIDInput | null,
  referenceNumber?: AdminModelSubscriptionStringInput | null,
  sellerId?: AdminModelSubscriptionIDInput | null,
  startDate?: AdminModelSubscriptionStringInput | null,
  status?: AdminModelSubscriptionStringInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionApplicationSubscriptionFilterInput | null > | null,
  or?: Array< ModelSubscriptionApplicationSubscriptionFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelSubscriptionApplicationSubscriptionVariousOperationFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  applicationSubscriptionId?: AdminModelSubscriptionIDInput | null,
  clientId?: AdminModelSubscriptionIDInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  endDate?: AdminModelSubscriptionStringInput | null,
  label?: AdminModelSubscriptionStringInput | null,
  lastInvoiceDate?: AdminModelSubscriptionStringInput | null,
  sellerId?: AdminModelSubscriptionIDInput | null,
  startDate?: AdminModelSubscriptionStringInput | null,
  type?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionApplicationSubscriptionVariousOperationFilterInput | null > | null,
  or?: Array< ModelSubscriptionApplicationSubscriptionVariousOperationFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelSubscriptionApplicationVariousOperationFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  amount?: AdminModelSubscriptionFloatInput | null,
  customerVisible?: AdminModelSubscriptionBooleanInput | null,
  duration?: AdminModelSubscriptionStringInput | null,
  numberOfCredits?: AdminModelSubscriptionFloatInput | null,
  type?: AdminModelSubscriptionStringInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionApplicationVariousOperationFilterInput | null > | null,
  or?: Array< ModelSubscriptionApplicationVariousOperationFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelSubscriptionCompanyUserFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  cognitoSub?: AdminModelSubscriptionIDInput | null,
  email?: AdminModelSubscriptionStringInput | null,
  firstName?: AdminModelSubscriptionStringInput | null,
  language?: AdminModelSubscriptionStringInput | null,
  lastName?: AdminModelSubscriptionStringInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCompanyUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionCompanyUserFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelSubscriptionCreditCostFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  clientId?: AdminModelSubscriptionIDInput | null,
  endDate?: AdminModelSubscriptionStringInput | null,
  numberOfCredits?: AdminModelSubscriptionFloatInput | null,
  price?: AdminModelSubscriptionFloatInput | null,
  startDate?: AdminModelSubscriptionStringInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCreditCostFilterInput | null > | null,
  or?: Array< ModelSubscriptionCreditCostFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelSubscriptionCreditUsageCostFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  endDate?: AdminModelSubscriptionStringInput | null,
  numberOfCreditsPerOperation?: AdminModelSubscriptionFloatInput | null,
  startDate?: AdminModelSubscriptionStringInput | null,
  type?: AdminModelSubscriptionStringInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCreditUsageCostFilterInput | null > | null,
  or?: Array< ModelSubscriptionCreditUsageCostFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type ModelSubscriptionSubscriptionUsageHistoryFilterInput = {
  id?: AdminModelSubscriptionIDInput | null,
  clientId?: AdminModelSubscriptionIDInput | null,
  createdAt?: AdminModelSubscriptionStringInput | null,
  customerCreatorId?: AdminModelSubscriptionIDInput | null,
  requestId?: AdminModelSubscriptionIDInput | null,
  applicationInvoiceId?: AdminModelSubscriptionIDInput | null,
  type?: AdminModelSubscriptionStringInput | null,
  updatedAt?: AdminModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSubscriptionUsageHistoryFilterInput | null > | null,
  or?: Array< ModelSubscriptionSubscriptionUsageHistoryFilterInput | null > | null,
  _deleted?: AdminModelBooleanInput | null,
};

export type CreateDocumentNumberMutationVariables = {
  input: CreateDocumentNumberInput,
  condition?: ModelDocumentNumberConditionInput | null,
};

export type CreateDocumentNumberMutation = {
  createDocumentNumber?:  {
    __typename: "DocumentNumber",
    id: string,
    format: string,
    lastUpdate: string,
    incrementNumber: number,
    type: ApplicationInvoiceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateDocumentNumberMutationVariables = {
  input: UpdateDocumentNumberInput,
  condition?: ModelDocumentNumberConditionInput | null,
};

export type UpdateDocumentNumberMutation = {
  updateDocumentNumber?:  {
    __typename: "DocumentNumber",
    id: string,
    format: string,
    lastUpdate: string,
    incrementNumber: number,
    type: ApplicationInvoiceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteDocumentNumberMutationVariables = {
  input: DeleteDocumentNumberInput,
  condition?: ModelDocumentNumberConditionInput | null,
};

export type DeleteDocumentNumberMutation = {
  deleteDocumentNumber?:  {
    __typename: "DocumentNumber",
    id: string,
    format: string,
    lastUpdate: string,
    incrementNumber: number,
    type: ApplicationInvoiceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CancelConsumedCreditsMutationVariables = {
  input: CancelConsumedCreditsInput,
};

export type CancelConsumedCreditsMutation = {
  cancelConsumedCredits?:  {
    __typename: "CancelConsumedCreditsResponse",
    creditsBalance: number,
    creditsCanceled: number,
    success: boolean,
  } | null,
};

export type ResendApplicationInvoiceToPeppolMutationVariables = {
  input: ResendApplicationInvoiceToPeppolInput,
};

export type ResendApplicationInvoiceToPeppolMutation = {
  resendApplicationInvoiceToPeppol?:  {
    __typename: "ResendApplicationInvoiceToPeppolResponse",
    applicationInvoiceId: string,
    message?: string | null,
    success: boolean,
  } | null,
};

export type CreateAdminCommunicationMutationVariables = {
  input: CreateAdminCommunicationInput,
  condition?: ModelAdminCommunicationConditionInput | null,
};

export type CreateAdminCommunicationMutation = {
  createAdminCommunication?:  {
    __typename: "AdminCommunication",
    id: string,
    body: string,
    clientId: string,
    createdAt: string,
    externalId?: string | null,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    applicationInvoiceId?: string | null,
    recipient?: string | null,
    sentAt?: string | null,
    status: AdminCommunicationStatus,
    subject: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAdminCommunicationMutationVariables = {
  input: UpdateAdminCommunicationInput,
  condition?: ModelAdminCommunicationConditionInput | null,
};

export type UpdateAdminCommunicationMutation = {
  updateAdminCommunication?:  {
    __typename: "AdminCommunication",
    id: string,
    body: string,
    clientId: string,
    createdAt: string,
    externalId?: string | null,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    applicationInvoiceId?: string | null,
    recipient?: string | null,
    sentAt?: string | null,
    status: AdminCommunicationStatus,
    subject: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAdminCommunicationMutationVariables = {
  input: DeleteAdminCommunicationInput,
  condition?: ModelAdminCommunicationConditionInput | null,
};

export type DeleteAdminCommunicationMutation = {
  deleteAdminCommunication?:  {
    __typename: "AdminCommunication",
    id: string,
    body: string,
    clientId: string,
    createdAt: string,
    externalId?: string | null,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    applicationInvoiceId?: string | null,
    recipient?: string | null,
    sentAt?: string | null,
    status: AdminCommunicationStatus,
    subject: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAdminFileMutationVariables = {
  input: CreateAdminFileInput,
  condition?: ModelAdminFileConditionInput | null,
};

export type CreateAdminFileMutation = {
  createAdminFile?:  {
    __typename: "AdminFile",
    id: string,
    bucket: string,
    createdAt: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    size?: number | null,
    clientId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAdminFileMutationVariables = {
  input: UpdateAdminFileInput,
  condition?: ModelAdminFileConditionInput | null,
};

export type UpdateAdminFileMutation = {
  updateAdminFile?:  {
    __typename: "AdminFile",
    id: string,
    bucket: string,
    createdAt: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    size?: number | null,
    clientId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAdminFileMutationVariables = {
  input: DeleteAdminFileInput,
  condition?: ModelAdminFileConditionInput | null,
};

export type DeleteAdminFileMutation = {
  deleteAdminFile?:  {
    __typename: "AdminFile",
    id: string,
    bucket: string,
    createdAt: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    size?: number | null,
    clientId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateApplicationInvoiceMutationVariables = {
  input: CreateApplicationInvoiceInput,
  condition?: ModelApplicationInvoiceConditionInput | null,
};

export type CreateApplicationInvoiceMutation = {
  createApplicationInvoice?:  {
    __typename: "ApplicationInvoice",
    id: string,
    amount: number,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceLines?:  {
      __typename: "ModelApplicationInvoiceLineConnection",
      items:  Array< {
        __typename: "ApplicationInvoiceLine",
        id: string,
        amountVatExcluded: number,
        applicationInvoiceId: string,
        calculationMethod?: ApplicationPlanCalculationMethod | null,
        clientId: string,
        customLabel?: string | null,
        extraInformation?: ApplicationInvoiceLineExtraInformation | null,
        quantity: number,
        periodFrom?: string | null,
        periodTo?: string | null,
        subscriptionVariousOperationId?: string | null,
        subscriptionUsageHistoryId?: string | null,
        totalAmount: number,
        type: ApplicationInvoiceLineType,
        vatAmount?: number | null,
        vatRate?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoiceNumber?: string | null,
    periodFrom: string,
    periodTo: string,
    clientSnapshot?:  {
      __typename: "ApplicationInvoiceClientSnapshot",
      name: string,
      vat?: string | null,
      businessNumber?: string | null,
      email?: string | null,
      address?:  {
        __typename: "ApplicationInvoiceClientSnapshotAddress",
        street?: string | null,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        country?: string | null,
      } | null,
    } | null,
    peppolProperties?:  {
      __typename: "ApplicationInvoicePeppolProperties",
      peppolStatus?: InvoicePeppolStatus | null,
      peppolId?: string | null,
      peppolErrorType?: string | null,
      peppolErrorMessage?: string | null,
    } | null,
    status: ApplicationInvoiceStatus,
    type: ApplicationInvoiceType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateApplicationInvoiceMutationVariables = {
  input: UpdateApplicationInvoiceInput,
  condition?: ModelApplicationInvoiceConditionInput | null,
};

export type UpdateApplicationInvoiceMutation = {
  updateApplicationInvoice?:  {
    __typename: "ApplicationInvoice",
    id: string,
    amount: number,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceLines?:  {
      __typename: "ModelApplicationInvoiceLineConnection",
      items:  Array< {
        __typename: "ApplicationInvoiceLine",
        id: string,
        amountVatExcluded: number,
        applicationInvoiceId: string,
        calculationMethod?: ApplicationPlanCalculationMethod | null,
        clientId: string,
        customLabel?: string | null,
        extraInformation?: ApplicationInvoiceLineExtraInformation | null,
        quantity: number,
        periodFrom?: string | null,
        periodTo?: string | null,
        subscriptionVariousOperationId?: string | null,
        subscriptionUsageHistoryId?: string | null,
        totalAmount: number,
        type: ApplicationInvoiceLineType,
        vatAmount?: number | null,
        vatRate?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoiceNumber?: string | null,
    periodFrom: string,
    periodTo: string,
    clientSnapshot?:  {
      __typename: "ApplicationInvoiceClientSnapshot",
      name: string,
      vat?: string | null,
      businessNumber?: string | null,
      email?: string | null,
      address?:  {
        __typename: "ApplicationInvoiceClientSnapshotAddress",
        street?: string | null,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        country?: string | null,
      } | null,
    } | null,
    peppolProperties?:  {
      __typename: "ApplicationInvoicePeppolProperties",
      peppolStatus?: InvoicePeppolStatus | null,
      peppolId?: string | null,
      peppolErrorType?: string | null,
      peppolErrorMessage?: string | null,
    } | null,
    status: ApplicationInvoiceStatus,
    type: ApplicationInvoiceType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteApplicationInvoiceMutationVariables = {
  input: DeleteApplicationInvoiceInput,
  condition?: ModelApplicationInvoiceConditionInput | null,
};

export type DeleteApplicationInvoiceMutation = {
  deleteApplicationInvoice?:  {
    __typename: "ApplicationInvoice",
    id: string,
    amount: number,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceLines?:  {
      __typename: "ModelApplicationInvoiceLineConnection",
      items:  Array< {
        __typename: "ApplicationInvoiceLine",
        id: string,
        amountVatExcluded: number,
        applicationInvoiceId: string,
        calculationMethod?: ApplicationPlanCalculationMethod | null,
        clientId: string,
        customLabel?: string | null,
        extraInformation?: ApplicationInvoiceLineExtraInformation | null,
        quantity: number,
        periodFrom?: string | null,
        periodTo?: string | null,
        subscriptionVariousOperationId?: string | null,
        subscriptionUsageHistoryId?: string | null,
        totalAmount: number,
        type: ApplicationInvoiceLineType,
        vatAmount?: number | null,
        vatRate?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoiceNumber?: string | null,
    periodFrom: string,
    periodTo: string,
    clientSnapshot?:  {
      __typename: "ApplicationInvoiceClientSnapshot",
      name: string,
      vat?: string | null,
      businessNumber?: string | null,
      email?: string | null,
      address?:  {
        __typename: "ApplicationInvoiceClientSnapshotAddress",
        street?: string | null,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        country?: string | null,
      } | null,
    } | null,
    peppolProperties?:  {
      __typename: "ApplicationInvoicePeppolProperties",
      peppolStatus?: InvoicePeppolStatus | null,
      peppolId?: string | null,
      peppolErrorType?: string | null,
      peppolErrorMessage?: string | null,
    } | null,
    status: ApplicationInvoiceStatus,
    type: ApplicationInvoiceType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateApplicationInvoiceLineMutationVariables = {
  input: CreateApplicationInvoiceLineInput,
  condition?: ModelApplicationInvoiceLineConditionInput | null,
};

export type CreateApplicationInvoiceLineMutation = {
  createApplicationInvoiceLine?:  {
    __typename: "ApplicationInvoiceLine",
    id: string,
    amountVatExcluded: number,
    applicationInvoiceId: string,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    calculationDetail?:  {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } | null,
    calculationMethod?: ApplicationPlanCalculationMethod | null,
    clientId: string,
    customLabel?: string | null,
    extraInformation?: ApplicationInvoiceLineExtraInformation | null,
    quantity: number,
    periodFrom?: string | null,
    periodTo?: string | null,
    subscriptionVariousOperationId?: string | null,
    subscriptionVariousOperation?:  {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    subscriptionUsageHistoryId?: string | null,
    subscriptionUsageHistory?:  {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    totalAmount: number,
    type: ApplicationInvoiceLineType,
    vatAmount?: number | null,
    vatRate?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateApplicationInvoiceLineMutationVariables = {
  input: UpdateApplicationInvoiceLineInput,
  condition?: ModelApplicationInvoiceLineConditionInput | null,
};

export type UpdateApplicationInvoiceLineMutation = {
  updateApplicationInvoiceLine?:  {
    __typename: "ApplicationInvoiceLine",
    id: string,
    amountVatExcluded: number,
    applicationInvoiceId: string,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    calculationDetail?:  {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } | null,
    calculationMethod?: ApplicationPlanCalculationMethod | null,
    clientId: string,
    customLabel?: string | null,
    extraInformation?: ApplicationInvoiceLineExtraInformation | null,
    quantity: number,
    periodFrom?: string | null,
    periodTo?: string | null,
    subscriptionVariousOperationId?: string | null,
    subscriptionVariousOperation?:  {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    subscriptionUsageHistoryId?: string | null,
    subscriptionUsageHistory?:  {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    totalAmount: number,
    type: ApplicationInvoiceLineType,
    vatAmount?: number | null,
    vatRate?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteApplicationInvoiceLineMutationVariables = {
  input: DeleteApplicationInvoiceLineInput,
  condition?: ModelApplicationInvoiceLineConditionInput | null,
};

export type DeleteApplicationInvoiceLineMutation = {
  deleteApplicationInvoiceLine?:  {
    __typename: "ApplicationInvoiceLine",
    id: string,
    amountVatExcluded: number,
    applicationInvoiceId: string,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    calculationDetail?:  {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } | null,
    calculationMethod?: ApplicationPlanCalculationMethod | null,
    clientId: string,
    customLabel?: string | null,
    extraInformation?: ApplicationInvoiceLineExtraInformation | null,
    quantity: number,
    periodFrom?: string | null,
    periodTo?: string | null,
    subscriptionVariousOperationId?: string | null,
    subscriptionVariousOperation?:  {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    subscriptionUsageHistoryId?: string | null,
    subscriptionUsageHistory?:  {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    totalAmount: number,
    type: ApplicationInvoiceLineType,
    vatAmount?: number | null,
    vatRate?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateApplicationPlanMutationVariables = {
  input: CreateApplicationPlanInput,
  condition?: ModelApplicationPlanConditionInput | null,
};

export type CreateApplicationPlanMutation = {
  createApplicationPlan?:  {
    __typename: "ApplicationPlan",
    id: string,
    calculationDetails:  Array< {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } >,
    calculationMethod: ApplicationPlanCalculationMethod,
    includedVariousOperations?:  {
      __typename: "ModelApplicationVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationVariousOperation",
        id: string,
        amount: number,
        customerVisible: boolean,
        duration: ApplicationVariousOperationDuration,
        numberOfCredits?: number | null,
        type: ApplicationVariousOperationType,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        applicationPlanIncludedVariousOperationsId: string,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    isBillable: boolean,
    isDefaultPlan: boolean,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfTrialMonths: number,
    setupFees: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateApplicationPlanMutationVariables = {
  input: UpdateApplicationPlanInput,
  condition?: ModelApplicationPlanConditionInput | null,
};

export type UpdateApplicationPlanMutation = {
  updateApplicationPlan?:  {
    __typename: "ApplicationPlan",
    id: string,
    calculationDetails:  Array< {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } >,
    calculationMethod: ApplicationPlanCalculationMethod,
    includedVariousOperations?:  {
      __typename: "ModelApplicationVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationVariousOperation",
        id: string,
        amount: number,
        customerVisible: boolean,
        duration: ApplicationVariousOperationDuration,
        numberOfCredits?: number | null,
        type: ApplicationVariousOperationType,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        applicationPlanIncludedVariousOperationsId: string,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    isBillable: boolean,
    isDefaultPlan: boolean,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfTrialMonths: number,
    setupFees: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteApplicationPlanMutationVariables = {
  input: DeleteApplicationPlanInput,
  condition?: ModelApplicationPlanConditionInput | null,
};

export type DeleteApplicationPlanMutation = {
  deleteApplicationPlan?:  {
    __typename: "ApplicationPlan",
    id: string,
    calculationDetails:  Array< {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } >,
    calculationMethod: ApplicationPlanCalculationMethod,
    includedVariousOperations?:  {
      __typename: "ModelApplicationVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationVariousOperation",
        id: string,
        amount: number,
        customerVisible: boolean,
        duration: ApplicationVariousOperationDuration,
        numberOfCredits?: number | null,
        type: ApplicationVariousOperationType,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        applicationPlanIncludedVariousOperationsId: string,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    isBillable: boolean,
    isDefaultPlan: boolean,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfTrialMonths: number,
    setupFees: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateApplicationSubscriptionMutationVariables = {
  input: CreateApplicationSubscriptionInput,
  condition?: ModelApplicationSubscriptionConditionInput | null,
};

export type CreateApplicationSubscriptionMutation = {
  createApplicationSubscription?:  {
    __typename: "ApplicationSubscription",
    id: string,
    clientId: string,
    creditsBalancePaid: number,
    creditsBalanceIncluded: number,
    creditsConfiguration:  {
      __typename: "CreditsConfiguration",
      allowPostPaid: boolean,
      creditsNotification: Array< CustomerNotification >,
      postPaidThreshold: number,
    },
    endDate?: string | null,
    language: Language,
    lastInvoiceDate?: string | null,
    paymentCustomerId?: string | null,
    paymentLastExecution?: string | null,
    paymentLastStatus: PaymentStatus,
    paymentLastError?: string | null,
    paymentMethodId?: string | null,
    paymentMode: PaymentMode,
    paymentTerms: PaymentTerms,
    invoicesProperties?:  {
      __typename: "InvoicesProperties",
      hideQuantities?: boolean | null,
    } | null,
    plan?:  {
      __typename: "ApplicationPlan",
      id: string,
      calculationDetails:  Array< {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } >,
      calculationMethod: ApplicationPlanCalculationMethod,
      includedVariousOperations?:  {
        __typename: "ModelApplicationVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      isBillable: boolean,
      isDefaultPlan: boolean,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfTrialMonths: number,
      setupFees: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    planId: string,
    referenceNumber?: string | null,
    seller?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sellerId?: string | null,
    startDate: string,
    status: ApplicationSubscriptionStatus,
    subscriptionVariousOperations?:  {
      __typename: "ModelApplicationSubscriptionVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateApplicationSubscriptionMutationVariables = {
  input: UpdateApplicationSubscriptionInput,
  condition?: ModelApplicationSubscriptionConditionInput | null,
};

export type UpdateApplicationSubscriptionMutation = {
  updateApplicationSubscription?:  {
    __typename: "ApplicationSubscription",
    id: string,
    clientId: string,
    creditsBalancePaid: number,
    creditsBalanceIncluded: number,
    creditsConfiguration:  {
      __typename: "CreditsConfiguration",
      allowPostPaid: boolean,
      creditsNotification: Array< CustomerNotification >,
      postPaidThreshold: number,
    },
    endDate?: string | null,
    language: Language,
    lastInvoiceDate?: string | null,
    paymentCustomerId?: string | null,
    paymentLastExecution?: string | null,
    paymentLastStatus: PaymentStatus,
    paymentLastError?: string | null,
    paymentMethodId?: string | null,
    paymentMode: PaymentMode,
    paymentTerms: PaymentTerms,
    invoicesProperties?:  {
      __typename: "InvoicesProperties",
      hideQuantities?: boolean | null,
    } | null,
    plan?:  {
      __typename: "ApplicationPlan",
      id: string,
      calculationDetails:  Array< {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } >,
      calculationMethod: ApplicationPlanCalculationMethod,
      includedVariousOperations?:  {
        __typename: "ModelApplicationVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      isBillable: boolean,
      isDefaultPlan: boolean,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfTrialMonths: number,
      setupFees: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    planId: string,
    referenceNumber?: string | null,
    seller?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sellerId?: string | null,
    startDate: string,
    status: ApplicationSubscriptionStatus,
    subscriptionVariousOperations?:  {
      __typename: "ModelApplicationSubscriptionVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteApplicationSubscriptionMutationVariables = {
  input: DeleteApplicationSubscriptionInput,
  condition?: ModelApplicationSubscriptionConditionInput | null,
};

export type DeleteApplicationSubscriptionMutation = {
  deleteApplicationSubscription?:  {
    __typename: "ApplicationSubscription",
    id: string,
    clientId: string,
    creditsBalancePaid: number,
    creditsBalanceIncluded: number,
    creditsConfiguration:  {
      __typename: "CreditsConfiguration",
      allowPostPaid: boolean,
      creditsNotification: Array< CustomerNotification >,
      postPaidThreshold: number,
    },
    endDate?: string | null,
    language: Language,
    lastInvoiceDate?: string | null,
    paymentCustomerId?: string | null,
    paymentLastExecution?: string | null,
    paymentLastStatus: PaymentStatus,
    paymentLastError?: string | null,
    paymentMethodId?: string | null,
    paymentMode: PaymentMode,
    paymentTerms: PaymentTerms,
    invoicesProperties?:  {
      __typename: "InvoicesProperties",
      hideQuantities?: boolean | null,
    } | null,
    plan?:  {
      __typename: "ApplicationPlan",
      id: string,
      calculationDetails:  Array< {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } >,
      calculationMethod: ApplicationPlanCalculationMethod,
      includedVariousOperations?:  {
        __typename: "ModelApplicationVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      isBillable: boolean,
      isDefaultPlan: boolean,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfTrialMonths: number,
      setupFees: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    planId: string,
    referenceNumber?: string | null,
    seller?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sellerId?: string | null,
    startDate: string,
    status: ApplicationSubscriptionStatus,
    subscriptionVariousOperations?:  {
      __typename: "ModelApplicationSubscriptionVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateApplicationSubscriptionVariousOperationMutationVariables = {
  input: CreateApplicationSubscriptionVariousOperationInput,
  condition?: ModelApplicationSubscriptionVariousOperationConditionInput | null,
};

export type CreateApplicationSubscriptionVariousOperationMutation = {
  createApplicationSubscriptionVariousOperation?:  {
    __typename: "ApplicationSubscriptionVariousOperation",
    id: string,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate?: string | null,
    label: string,
    lastInvoiceDate?: string | null,
    sellerId: string,
    startDate: string,
    subscriptionVariousOperationHistories:  Array< {
      __typename: "SubscriptionVariousOperationHistory",
      periodFrom: string,
      periodTo?: string | null,
      amount: number,
    } >,
    type: ApplicationVariousOperationType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateApplicationSubscriptionVariousOperationMutationVariables = {
  input: UpdateApplicationSubscriptionVariousOperationInput,
  condition?: ModelApplicationSubscriptionVariousOperationConditionInput | null,
};

export type UpdateApplicationSubscriptionVariousOperationMutation = {
  updateApplicationSubscriptionVariousOperation?:  {
    __typename: "ApplicationSubscriptionVariousOperation",
    id: string,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate?: string | null,
    label: string,
    lastInvoiceDate?: string | null,
    sellerId: string,
    startDate: string,
    subscriptionVariousOperationHistories:  Array< {
      __typename: "SubscriptionVariousOperationHistory",
      periodFrom: string,
      periodTo?: string | null,
      amount: number,
    } >,
    type: ApplicationVariousOperationType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteApplicationSubscriptionVariousOperationMutationVariables = {
  input: DeleteApplicationSubscriptionVariousOperationInput,
  condition?: ModelApplicationSubscriptionVariousOperationConditionInput | null,
};

export type DeleteApplicationSubscriptionVariousOperationMutation = {
  deleteApplicationSubscriptionVariousOperation?:  {
    __typename: "ApplicationSubscriptionVariousOperation",
    id: string,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate?: string | null,
    label: string,
    lastInvoiceDate?: string | null,
    sellerId: string,
    startDate: string,
    subscriptionVariousOperationHistories:  Array< {
      __typename: "SubscriptionVariousOperationHistory",
      periodFrom: string,
      periodTo?: string | null,
      amount: number,
    } >,
    type: ApplicationVariousOperationType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateApplicationVariousOperationMutationVariables = {
  input: CreateApplicationVariousOperationInput,
  condition?: ModelApplicationVariousOperationConditionInput | null,
};

export type CreateApplicationVariousOperationMutation = {
  createApplicationVariousOperation?:  {
    __typename: "ApplicationVariousOperation",
    id: string,
    amount: number,
    customerVisible: boolean,
    duration: ApplicationVariousOperationDuration,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfCredits?: number | null,
    type: ApplicationVariousOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    applicationPlanIncludedVariousOperationsId: string,
  } | null,
};

export type UpdateApplicationVariousOperationMutationVariables = {
  input: UpdateApplicationVariousOperationInput,
  condition?: ModelApplicationVariousOperationConditionInput | null,
};

export type UpdateApplicationVariousOperationMutation = {
  updateApplicationVariousOperation?:  {
    __typename: "ApplicationVariousOperation",
    id: string,
    amount: number,
    customerVisible: boolean,
    duration: ApplicationVariousOperationDuration,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfCredits?: number | null,
    type: ApplicationVariousOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    applicationPlanIncludedVariousOperationsId: string,
  } | null,
};

export type DeleteApplicationVariousOperationMutationVariables = {
  input: DeleteApplicationVariousOperationInput,
  condition?: ModelApplicationVariousOperationConditionInput | null,
};

export type DeleteApplicationVariousOperationMutation = {
  deleteApplicationVariousOperation?:  {
    __typename: "ApplicationVariousOperation",
    id: string,
    amount: number,
    customerVisible: boolean,
    duration: ApplicationVariousOperationDuration,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfCredits?: number | null,
    type: ApplicationVariousOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    applicationPlanIncludedVariousOperationsId: string,
  } | null,
};

export type CreateCompanyUserMutationVariables = {
  input: CreateCompanyUserInput,
  condition?: ModelCompanyUserConditionInput | null,
};

export type CreateCompanyUserMutation = {
  createCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    cognitoSub?: string | null,
    email: string,
    firstName: string,
    language?: Language | null,
    lastName: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCompanyUserMutationVariables = {
  input: UpdateCompanyUserInput,
  condition?: ModelCompanyUserConditionInput | null,
};

export type UpdateCompanyUserMutation = {
  updateCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    cognitoSub?: string | null,
    email: string,
    firstName: string,
    language?: Language | null,
    lastName: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCompanyUserMutationVariables = {
  input: DeleteCompanyUserInput,
  condition?: ModelCompanyUserConditionInput | null,
};

export type DeleteCompanyUserMutation = {
  deleteCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    cognitoSub?: string | null,
    email: string,
    firstName: string,
    language?: Language | null,
    lastName: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateCreditCostMutationVariables = {
  input: CreateCreditCostInput,
  condition?: ModelCreditCostConditionInput | null,
};

export type CreateCreditCostMutation = {
  createCreditCost?:  {
    __typename: "CreditCost",
    id: string,
    clientId?: string | null,
    endDate?: string | null,
    numberOfCredits: number,
    price: number,
    startDate: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCreditCostMutationVariables = {
  input: UpdateCreditCostInput,
  condition?: ModelCreditCostConditionInput | null,
};

export type UpdateCreditCostMutation = {
  updateCreditCost?:  {
    __typename: "CreditCost",
    id: string,
    clientId?: string | null,
    endDate?: string | null,
    numberOfCredits: number,
    price: number,
    startDate: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCreditCostMutationVariables = {
  input: DeleteCreditCostInput,
  condition?: ModelCreditCostConditionInput | null,
};

export type DeleteCreditCostMutation = {
  deleteCreditCost?:  {
    __typename: "CreditCost",
    id: string,
    clientId?: string | null,
    endDate?: string | null,
    numberOfCredits: number,
    price: number,
    startDate: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateCreditUsageCostMutationVariables = {
  input: CreateCreditUsageCostInput,
  condition?: ModelCreditUsageCostConditionInput | null,
};

export type CreateCreditUsageCostMutation = {
  createCreditUsageCost?:  {
    __typename: "CreditUsageCost",
    id: string,
    endDate?: string | null,
    numberOfCreditsPerOperation: number,
    startDate: string,
    type: CreditOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCreditUsageCostMutationVariables = {
  input: UpdateCreditUsageCostInput,
  condition?: ModelCreditUsageCostConditionInput | null,
};

export type UpdateCreditUsageCostMutation = {
  updateCreditUsageCost?:  {
    __typename: "CreditUsageCost",
    id: string,
    endDate?: string | null,
    numberOfCreditsPerOperation: number,
    startDate: string,
    type: CreditOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCreditUsageCostMutationVariables = {
  input: DeleteCreditUsageCostInput,
  condition?: ModelCreditUsageCostConditionInput | null,
};

export type DeleteCreditUsageCostMutation = {
  deleteCreditUsageCost?:  {
    __typename: "CreditUsageCost",
    id: string,
    endDate?: string | null,
    numberOfCreditsPerOperation: number,
    startDate: string,
    type: CreditOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSubscriptionUsageHistoryMutationVariables = {
  input: CreateSubscriptionUsageHistoryInput,
  condition?: ModelSubscriptionUsageHistoryConditionInput | null,
};

export type CreateSubscriptionUsageHistoryMutation = {
  createSubscriptionUsageHistory?:  {
    __typename: "SubscriptionUsageHistory",
    id: string,
    clientId: string,
    createdAt: string,
    creditUsageDetail?:  {
      __typename: "SubscriptionCreditUsageHistoryDetail",
      numberUsed: number,
      creditsAccount: CreditsAccount,
      creditOperationType: CreditOperationType,
    } | null,
    customerCreatorId?: string | null,
    requestId?: string | null,
    applicationInvoiceId?: string | null,
    storageUsageDetail?:  {
      __typename: "SubscriptionStorageUsageHistoryDetail",
      numberUsed: number,
    } | null,
    type: UsageType,
    unitsUsageDetail?:  {
      __typename: "SubscriptionUnitsUsageHistoryDetail",
      unitsUsage:  Array< {
        __typename: "SubscriptionUnitUsageHistoryDetail",
        numberUsed: number,
        unitId?: string | null,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
      proRataUnits:  Array< {
        __typename: "SubscriptionUnitProRataUsageHistoryDetail",
        unitId: string,
        numberOfDays: number,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSubscriptionUsageHistoryMutationVariables = {
  input: UpdateSubscriptionUsageHistoryInput,
  condition?: ModelSubscriptionUsageHistoryConditionInput | null,
};

export type UpdateSubscriptionUsageHistoryMutation = {
  updateSubscriptionUsageHistory?:  {
    __typename: "SubscriptionUsageHistory",
    id: string,
    clientId: string,
    createdAt: string,
    creditUsageDetail?:  {
      __typename: "SubscriptionCreditUsageHistoryDetail",
      numberUsed: number,
      creditsAccount: CreditsAccount,
      creditOperationType: CreditOperationType,
    } | null,
    customerCreatorId?: string | null,
    requestId?: string | null,
    applicationInvoiceId?: string | null,
    storageUsageDetail?:  {
      __typename: "SubscriptionStorageUsageHistoryDetail",
      numberUsed: number,
    } | null,
    type: UsageType,
    unitsUsageDetail?:  {
      __typename: "SubscriptionUnitsUsageHistoryDetail",
      unitsUsage:  Array< {
        __typename: "SubscriptionUnitUsageHistoryDetail",
        numberUsed: number,
        unitId?: string | null,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
      proRataUnits:  Array< {
        __typename: "SubscriptionUnitProRataUsageHistoryDetail",
        unitId: string,
        numberOfDays: number,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSubscriptionUsageHistoryMutationVariables = {
  input: DeleteSubscriptionUsageHistoryInput,
  condition?: ModelSubscriptionUsageHistoryConditionInput | null,
};

export type DeleteSubscriptionUsageHistoryMutation = {
  deleteSubscriptionUsageHistory?:  {
    __typename: "SubscriptionUsageHistory",
    id: string,
    clientId: string,
    createdAt: string,
    creditUsageDetail?:  {
      __typename: "SubscriptionCreditUsageHistoryDetail",
      numberUsed: number,
      creditsAccount: CreditsAccount,
      creditOperationType: CreditOperationType,
    } | null,
    customerCreatorId?: string | null,
    requestId?: string | null,
    applicationInvoiceId?: string | null,
    storageUsageDetail?:  {
      __typename: "SubscriptionStorageUsageHistoryDetail",
      numberUsed: number,
    } | null,
    type: UsageType,
    unitsUsageDetail?:  {
      __typename: "SubscriptionUnitsUsageHistoryDetail",
      unitsUsage:  Array< {
        __typename: "SubscriptionUnitUsageHistoryDetail",
        numberUsed: number,
        unitId?: string | null,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
      proRataUnits:  Array< {
        __typename: "SubscriptionUnitProRataUsageHistoryDetail",
        unitId: string,
        numberOfDays: number,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CheckAndConsumeCreditsMutationVariables = {
  input: CheckAndConsumeCreditsInput,
};

export type CheckAndConsumeCreditsMutation = {
  checkAndConsumeCredits?:  {
    __typename: "CheckAndConsumeCreditsResponse",
    creditsBalance: number,
    creditsNeeded: number,
    creditsUsed: number,
    status: CheckAndConsumeCreditsResponseStatus,
  } | null,
};

export type DisableClientAccountMutationVariables = {
  input: DisableClientAccountInput,
};

export type DisableClientAccountMutation = {
  disableClientAccount?:  {
    __typename: "DisableClientAccountResponse",
    deletionTime: string,
    success: boolean,
    errorMessage?: string | null,
  } | null,
};

export type GetDocumentNumberQueryVariables = {
  id: string,
};

export type GetDocumentNumberQuery = {
  getDocumentNumber?:  {
    __typename: "DocumentNumber",
    id: string,
    format: string,
    lastUpdate: string,
    incrementNumber: number,
    type: ApplicationInvoiceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListDocumentNumbersQueryVariables = {
  filter?: ModelDocumentNumberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDocumentNumbersQuery = {
  listDocumentNumbers?:  {
    __typename: "ModelDocumentNumberConnection",
    items:  Array< {
      __typename: "DocumentNumber",
      id: string,
      format: string,
      lastUpdate: string,
      incrementNumber: number,
      type: ApplicationInvoiceType,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncDocumentNumbersQueryVariables = {
  filter?: ModelDocumentNumberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncDocumentNumbersQuery = {
  syncDocumentNumbers?:  {
    __typename: "ModelDocumentNumberConnection",
    items:  Array< {
      __typename: "DocumentNumber",
      id: string,
      format: string,
      lastUpdate: string,
      incrementNumber: number,
      type: ApplicationInvoiceType,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAdminCommunicationQueryVariables = {
  id: string,
};

export type GetAdminCommunicationQuery = {
  getAdminCommunication?:  {
    __typename: "AdminCommunication",
    id: string,
    body: string,
    clientId: string,
    createdAt: string,
    externalId?: string | null,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    applicationInvoiceId?: string | null,
    recipient?: string | null,
    sentAt?: string | null,
    status: AdminCommunicationStatus,
    subject: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAdminCommunicationsQueryVariables = {
  filter?: ModelAdminCommunicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAdminCommunicationsQuery = {
  listAdminCommunications?:  {
    __typename: "ModelAdminCommunicationConnection",
    items:  Array< {
      __typename: "AdminCommunication",
      id: string,
      body: string,
      clientId: string,
      createdAt: string,
      externalId?: string | null,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      applicationInvoiceId?: string | null,
      recipient?: string | null,
      sentAt?: string | null,
      status: AdminCommunicationStatus,
      subject: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAdminCommunicationsQueryVariables = {
  filter?: ModelAdminCommunicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAdminCommunicationsQuery = {
  syncAdminCommunications?:  {
    __typename: "ModelAdminCommunicationConnection",
    items:  Array< {
      __typename: "AdminCommunication",
      id: string,
      body: string,
      clientId: string,
      createdAt: string,
      externalId?: string | null,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      applicationInvoiceId?: string | null,
      recipient?: string | null,
      sentAt?: string | null,
      status: AdminCommunicationStatus,
      subject: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type AdminCommunicationsByClientIdAndCreatedAtQueryVariables = {
  clientId: string,
  createdAt?: AdminModelStringKeyConditionInput | null,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelAdminCommunicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AdminCommunicationsByClientIdAndCreatedAtQuery = {
  adminCommunicationsByClientIdAndCreatedAt?:  {
    __typename: "ModelAdminCommunicationConnection",
    items:  Array< {
      __typename: "AdminCommunication",
      id: string,
      body: string,
      clientId: string,
      createdAt: string,
      externalId?: string | null,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      applicationInvoiceId?: string | null,
      recipient?: string | null,
      sentAt?: string | null,
      status: AdminCommunicationStatus,
      subject: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type AdminCommunicationsByExternalIdQueryVariables = {
  externalId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelAdminCommunicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AdminCommunicationsByExternalIdQuery = {
  adminCommunicationsByExternalId?:  {
    __typename: "ModelAdminCommunicationConnection",
    items:  Array< {
      __typename: "AdminCommunication",
      id: string,
      body: string,
      clientId: string,
      createdAt: string,
      externalId?: string | null,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      applicationInvoiceId?: string | null,
      recipient?: string | null,
      sentAt?: string | null,
      status: AdminCommunicationStatus,
      subject: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type AdminCommunicationsByApplicationInvoiceIdQueryVariables = {
  applicationInvoiceId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelAdminCommunicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AdminCommunicationsByApplicationInvoiceIdQuery = {
  adminCommunicationsByApplicationInvoiceId?:  {
    __typename: "ModelAdminCommunicationConnection",
    items:  Array< {
      __typename: "AdminCommunication",
      id: string,
      body: string,
      clientId: string,
      createdAt: string,
      externalId?: string | null,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      applicationInvoiceId?: string | null,
      recipient?: string | null,
      sentAt?: string | null,
      status: AdminCommunicationStatus,
      subject: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAdminFileQueryVariables = {
  id: string,
};

export type GetAdminFileQuery = {
  getAdminFile?:  {
    __typename: "AdminFile",
    id: string,
    bucket: string,
    createdAt: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    size?: number | null,
    clientId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAdminFilesQueryVariables = {
  filter?: ModelAdminFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAdminFilesQuery = {
  listAdminFiles?:  {
    __typename: "ModelAdminFileConnection",
    items:  Array< {
      __typename: "AdminFile",
      id: string,
      bucket: string,
      createdAt: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      size?: number | null,
      clientId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAdminFilesQueryVariables = {
  filter?: ModelAdminFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAdminFilesQuery = {
  syncAdminFiles?:  {
    __typename: "ModelAdminFileConnection",
    items:  Array< {
      __typename: "AdminFile",
      id: string,
      bucket: string,
      createdAt: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      size?: number | null,
      clientId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type AdminFilesByForeignKeyAndForeignTableNameQueryVariables = {
  foreignKey: string,
  foreignTableName?: AdminModelStringKeyConditionInput | null,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelAdminFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AdminFilesByForeignKeyAndForeignTableNameQuery = {
  adminFilesByForeignKeyAndForeignTableName?:  {
    __typename: "ModelAdminFileConnection",
    items:  Array< {
      __typename: "AdminFile",
      id: string,
      bucket: string,
      createdAt: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      size?: number | null,
      clientId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type AdminFilesByClientIdAndForeignTableNameQueryVariables = {
  clientId: string,
  foreignTableName?: AdminModelStringKeyConditionInput | null,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelAdminFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AdminFilesByClientIdAndForeignTableNameQuery = {
  adminFilesByClientIdAndForeignTableName?:  {
    __typename: "ModelAdminFileConnection",
    items:  Array< {
      __typename: "AdminFile",
      id: string,
      bucket: string,
      createdAt: string,
      foreignKey: string,
      foreignTableName: string,
      key: string,
      mimeType?: string | null,
      region: string,
      size?: number | null,
      clientId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetApplicationInvoiceQueryVariables = {
  id: string,
};

export type GetApplicationInvoiceQuery = {
  getApplicationInvoice?:  {
    __typename: "ApplicationInvoice",
    id: string,
    amount: number,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceLines?:  {
      __typename: "ModelApplicationInvoiceLineConnection",
      items:  Array< {
        __typename: "ApplicationInvoiceLine",
        id: string,
        amountVatExcluded: number,
        applicationInvoiceId: string,
        calculationMethod?: ApplicationPlanCalculationMethod | null,
        clientId: string,
        customLabel?: string | null,
        extraInformation?: ApplicationInvoiceLineExtraInformation | null,
        quantity: number,
        periodFrom?: string | null,
        periodTo?: string | null,
        subscriptionVariousOperationId?: string | null,
        subscriptionUsageHistoryId?: string | null,
        totalAmount: number,
        type: ApplicationInvoiceLineType,
        vatAmount?: number | null,
        vatRate?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoiceNumber?: string | null,
    periodFrom: string,
    periodTo: string,
    clientSnapshot?:  {
      __typename: "ApplicationInvoiceClientSnapshot",
      name: string,
      vat?: string | null,
      businessNumber?: string | null,
      email?: string | null,
      address?:  {
        __typename: "ApplicationInvoiceClientSnapshotAddress",
        street?: string | null,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        country?: string | null,
      } | null,
    } | null,
    peppolProperties?:  {
      __typename: "ApplicationInvoicePeppolProperties",
      peppolStatus?: InvoicePeppolStatus | null,
      peppolId?: string | null,
      peppolErrorType?: string | null,
      peppolErrorMessage?: string | null,
    } | null,
    status: ApplicationInvoiceStatus,
    type: ApplicationInvoiceType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListApplicationInvoicesQueryVariables = {
  filter?: ModelApplicationInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListApplicationInvoicesQuery = {
  listApplicationInvoices?:  {
    __typename: "ModelApplicationInvoiceConnection",
    items:  Array< {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncApplicationInvoicesQueryVariables = {
  filter?: ModelApplicationInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncApplicationInvoicesQuery = {
  syncApplicationInvoices?:  {
    __typename: "ModelApplicationInvoiceConnection",
    items:  Array< {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationInvoicesByApplicationSubscriptionIdQueryVariables = {
  applicationSubscriptionId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationInvoicesByApplicationSubscriptionIdQuery = {
  applicationInvoicesByApplicationSubscriptionId?:  {
    __typename: "ModelApplicationInvoiceConnection",
    items:  Array< {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationInvoicesByClientIdAndInvoiceDateQueryVariables = {
  clientId: string,
  invoiceDate?: AdminModelStringKeyConditionInput | null,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationInvoicesByClientIdAndInvoiceDateQuery = {
  applicationInvoicesByClientIdAndInvoiceDate?:  {
    __typename: "ModelApplicationInvoiceConnection",
    items:  Array< {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationInvoicesByStatusAndInvoiceDateQueryVariables = {
  status: ApplicationInvoiceStatus,
  invoiceDate?: AdminModelStringKeyConditionInput | null,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationInvoicesByStatusAndInvoiceDateQuery = {
  applicationInvoicesByStatusAndInvoiceDate?:  {
    __typename: "ModelApplicationInvoiceConnection",
    items:  Array< {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationInvoicesByTypeAndInvoiceDateQueryVariables = {
  type: ApplicationInvoiceType,
  invoiceDate?: AdminModelStringKeyConditionInput | null,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationInvoiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationInvoicesByTypeAndInvoiceDateQuery = {
  applicationInvoicesByTypeAndInvoiceDate?:  {
    __typename: "ModelApplicationInvoiceConnection",
    items:  Array< {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetApplicationInvoiceLineQueryVariables = {
  id: string,
};

export type GetApplicationInvoiceLineQuery = {
  getApplicationInvoiceLine?:  {
    __typename: "ApplicationInvoiceLine",
    id: string,
    amountVatExcluded: number,
    applicationInvoiceId: string,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    calculationDetail?:  {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } | null,
    calculationMethod?: ApplicationPlanCalculationMethod | null,
    clientId: string,
    customLabel?: string | null,
    extraInformation?: ApplicationInvoiceLineExtraInformation | null,
    quantity: number,
    periodFrom?: string | null,
    periodTo?: string | null,
    subscriptionVariousOperationId?: string | null,
    subscriptionVariousOperation?:  {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    subscriptionUsageHistoryId?: string | null,
    subscriptionUsageHistory?:  {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    totalAmount: number,
    type: ApplicationInvoiceLineType,
    vatAmount?: number | null,
    vatRate?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListApplicationInvoiceLinesQueryVariables = {
  filter?: ModelApplicationInvoiceLineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListApplicationInvoiceLinesQuery = {
  listApplicationInvoiceLines?:  {
    __typename: "ModelApplicationInvoiceLineConnection",
    items:  Array< {
      __typename: "ApplicationInvoiceLine",
      id: string,
      amountVatExcluded: number,
      applicationInvoiceId: string,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      calculationDetail?:  {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } | null,
      calculationMethod?: ApplicationPlanCalculationMethod | null,
      clientId: string,
      customLabel?: string | null,
      extraInformation?: ApplicationInvoiceLineExtraInformation | null,
      quantity: number,
      periodFrom?: string | null,
      periodTo?: string | null,
      subscriptionVariousOperationId?: string | null,
      subscriptionVariousOperation?:  {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      subscriptionUsageHistoryId?: string | null,
      subscriptionUsageHistory?:  {
        __typename: "SubscriptionUsageHistory",
        id: string,
        clientId: string,
        createdAt: string,
        customerCreatorId?: string | null,
        requestId?: string | null,
        applicationInvoiceId?: string | null,
        type: UsageType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      totalAmount: number,
      type: ApplicationInvoiceLineType,
      vatAmount?: number | null,
      vatRate?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncApplicationInvoiceLinesQueryVariables = {
  filter?: ModelApplicationInvoiceLineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncApplicationInvoiceLinesQuery = {
  syncApplicationInvoiceLines?:  {
    __typename: "ModelApplicationInvoiceLineConnection",
    items:  Array< {
      __typename: "ApplicationInvoiceLine",
      id: string,
      amountVatExcluded: number,
      applicationInvoiceId: string,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      calculationDetail?:  {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } | null,
      calculationMethod?: ApplicationPlanCalculationMethod | null,
      clientId: string,
      customLabel?: string | null,
      extraInformation?: ApplicationInvoiceLineExtraInformation | null,
      quantity: number,
      periodFrom?: string | null,
      periodTo?: string | null,
      subscriptionVariousOperationId?: string | null,
      subscriptionVariousOperation?:  {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      subscriptionUsageHistoryId?: string | null,
      subscriptionUsageHistory?:  {
        __typename: "SubscriptionUsageHistory",
        id: string,
        clientId: string,
        createdAt: string,
        customerCreatorId?: string | null,
        requestId?: string | null,
        applicationInvoiceId?: string | null,
        type: UsageType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      totalAmount: number,
      type: ApplicationInvoiceLineType,
      vatAmount?: number | null,
      vatRate?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationInvoiceLinesByApplicationInvoiceIdQueryVariables = {
  applicationInvoiceId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationInvoiceLineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationInvoiceLinesByApplicationInvoiceIdQuery = {
  applicationInvoiceLinesByApplicationInvoiceId?:  {
    __typename: "ModelApplicationInvoiceLineConnection",
    items:  Array< {
      __typename: "ApplicationInvoiceLine",
      id: string,
      amountVatExcluded: number,
      applicationInvoiceId: string,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      calculationDetail?:  {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } | null,
      calculationMethod?: ApplicationPlanCalculationMethod | null,
      clientId: string,
      customLabel?: string | null,
      extraInformation?: ApplicationInvoiceLineExtraInformation | null,
      quantity: number,
      periodFrom?: string | null,
      periodTo?: string | null,
      subscriptionVariousOperationId?: string | null,
      subscriptionVariousOperation?:  {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      subscriptionUsageHistoryId?: string | null,
      subscriptionUsageHistory?:  {
        __typename: "SubscriptionUsageHistory",
        id: string,
        clientId: string,
        createdAt: string,
        customerCreatorId?: string | null,
        requestId?: string | null,
        applicationInvoiceId?: string | null,
        type: UsageType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      totalAmount: number,
      type: ApplicationInvoiceLineType,
      vatAmount?: number | null,
      vatRate?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationInvoiceLinesByClientIdQueryVariables = {
  clientId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationInvoiceLineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationInvoiceLinesByClientIdQuery = {
  applicationInvoiceLinesByClientId?:  {
    __typename: "ModelApplicationInvoiceLineConnection",
    items:  Array< {
      __typename: "ApplicationInvoiceLine",
      id: string,
      amountVatExcluded: number,
      applicationInvoiceId: string,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      calculationDetail?:  {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } | null,
      calculationMethod?: ApplicationPlanCalculationMethod | null,
      clientId: string,
      customLabel?: string | null,
      extraInformation?: ApplicationInvoiceLineExtraInformation | null,
      quantity: number,
      periodFrom?: string | null,
      periodTo?: string | null,
      subscriptionVariousOperationId?: string | null,
      subscriptionVariousOperation?:  {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      subscriptionUsageHistoryId?: string | null,
      subscriptionUsageHistory?:  {
        __typename: "SubscriptionUsageHistory",
        id: string,
        clientId: string,
        createdAt: string,
        customerCreatorId?: string | null,
        requestId?: string | null,
        applicationInvoiceId?: string | null,
        type: UsageType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      totalAmount: number,
      type: ApplicationInvoiceLineType,
      vatAmount?: number | null,
      vatRate?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationInvoiceLinesBySubscriptionVariousOperationIdQueryVariables = {
  subscriptionVariousOperationId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationInvoiceLineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationInvoiceLinesBySubscriptionVariousOperationIdQuery = {
  applicationInvoiceLinesBySubscriptionVariousOperationId?:  {
    __typename: "ModelApplicationInvoiceLineConnection",
    items:  Array< {
      __typename: "ApplicationInvoiceLine",
      id: string,
      amountVatExcluded: number,
      applicationInvoiceId: string,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      calculationDetail?:  {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } | null,
      calculationMethod?: ApplicationPlanCalculationMethod | null,
      clientId: string,
      customLabel?: string | null,
      extraInformation?: ApplicationInvoiceLineExtraInformation | null,
      quantity: number,
      periodFrom?: string | null,
      periodTo?: string | null,
      subscriptionVariousOperationId?: string | null,
      subscriptionVariousOperation?:  {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      subscriptionUsageHistoryId?: string | null,
      subscriptionUsageHistory?:  {
        __typename: "SubscriptionUsageHistory",
        id: string,
        clientId: string,
        createdAt: string,
        customerCreatorId?: string | null,
        requestId?: string | null,
        applicationInvoiceId?: string | null,
        type: UsageType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      totalAmount: number,
      type: ApplicationInvoiceLineType,
      vatAmount?: number | null,
      vatRate?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationInvoiceLinesBySubscriptionUsageHistoryIdQueryVariables = {
  subscriptionUsageHistoryId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationInvoiceLineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationInvoiceLinesBySubscriptionUsageHistoryIdQuery = {
  applicationInvoiceLinesBySubscriptionUsageHistoryId?:  {
    __typename: "ModelApplicationInvoiceLineConnection",
    items:  Array< {
      __typename: "ApplicationInvoiceLine",
      id: string,
      amountVatExcluded: number,
      applicationInvoiceId: string,
      applicationInvoice?:  {
        __typename: "ApplicationInvoice",
        id: string,
        amount: number,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        dueDate?: string | null,
        invoiceDate: string,
        invoiceNumber?: string | null,
        periodFrom: string,
        periodTo: string,
        status: ApplicationInvoiceStatus,
        type: ApplicationInvoiceType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      calculationDetail?:  {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } | null,
      calculationMethod?: ApplicationPlanCalculationMethod | null,
      clientId: string,
      customLabel?: string | null,
      extraInformation?: ApplicationInvoiceLineExtraInformation | null,
      quantity: number,
      periodFrom?: string | null,
      periodTo?: string | null,
      subscriptionVariousOperationId?: string | null,
      subscriptionVariousOperation?:  {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      subscriptionUsageHistoryId?: string | null,
      subscriptionUsageHistory?:  {
        __typename: "SubscriptionUsageHistory",
        id: string,
        clientId: string,
        createdAt: string,
        customerCreatorId?: string | null,
        requestId?: string | null,
        applicationInvoiceId?: string | null,
        type: UsageType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      totalAmount: number,
      type: ApplicationInvoiceLineType,
      vatAmount?: number | null,
      vatRate?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetApplicationPlanQueryVariables = {
  id: string,
};

export type GetApplicationPlanQuery = {
  getApplicationPlan?:  {
    __typename: "ApplicationPlan",
    id: string,
    calculationDetails:  Array< {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } >,
    calculationMethod: ApplicationPlanCalculationMethod,
    includedVariousOperations?:  {
      __typename: "ModelApplicationVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationVariousOperation",
        id: string,
        amount: number,
        customerVisible: boolean,
        duration: ApplicationVariousOperationDuration,
        numberOfCredits?: number | null,
        type: ApplicationVariousOperationType,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        applicationPlanIncludedVariousOperationsId: string,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    isBillable: boolean,
    isDefaultPlan: boolean,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfTrialMonths: number,
    setupFees: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListApplicationPlansQueryVariables = {
  filter?: ModelApplicationPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListApplicationPlansQuery = {
  listApplicationPlans?:  {
    __typename: "ModelApplicationPlanConnection",
    items:  Array< {
      __typename: "ApplicationPlan",
      id: string,
      calculationDetails:  Array< {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } >,
      calculationMethod: ApplicationPlanCalculationMethod,
      includedVariousOperations?:  {
        __typename: "ModelApplicationVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      isBillable: boolean,
      isDefaultPlan: boolean,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfTrialMonths: number,
      setupFees: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncApplicationPlansQueryVariables = {
  filter?: ModelApplicationPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncApplicationPlansQuery = {
  syncApplicationPlans?:  {
    __typename: "ModelApplicationPlanConnection",
    items:  Array< {
      __typename: "ApplicationPlan",
      id: string,
      calculationDetails:  Array< {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } >,
      calculationMethod: ApplicationPlanCalculationMethod,
      includedVariousOperations?:  {
        __typename: "ModelApplicationVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      isBillable: boolean,
      isDefaultPlan: boolean,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfTrialMonths: number,
      setupFees: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetApplicationSubscriptionQueryVariables = {
  id: string,
};

export type GetApplicationSubscriptionQuery = {
  getApplicationSubscription?:  {
    __typename: "ApplicationSubscription",
    id: string,
    clientId: string,
    creditsBalancePaid: number,
    creditsBalanceIncluded: number,
    creditsConfiguration:  {
      __typename: "CreditsConfiguration",
      allowPostPaid: boolean,
      creditsNotification: Array< CustomerNotification >,
      postPaidThreshold: number,
    },
    endDate?: string | null,
    language: Language,
    lastInvoiceDate?: string | null,
    paymentCustomerId?: string | null,
    paymentLastExecution?: string | null,
    paymentLastStatus: PaymentStatus,
    paymentLastError?: string | null,
    paymentMethodId?: string | null,
    paymentMode: PaymentMode,
    paymentTerms: PaymentTerms,
    invoicesProperties?:  {
      __typename: "InvoicesProperties",
      hideQuantities?: boolean | null,
    } | null,
    plan?:  {
      __typename: "ApplicationPlan",
      id: string,
      calculationDetails:  Array< {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } >,
      calculationMethod: ApplicationPlanCalculationMethod,
      includedVariousOperations?:  {
        __typename: "ModelApplicationVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      isBillable: boolean,
      isDefaultPlan: boolean,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfTrialMonths: number,
      setupFees: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    planId: string,
    referenceNumber?: string | null,
    seller?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sellerId?: string | null,
    startDate: string,
    status: ApplicationSubscriptionStatus,
    subscriptionVariousOperations?:  {
      __typename: "ModelApplicationSubscriptionVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListApplicationSubscriptionsQueryVariables = {
  filter?: ModelApplicationSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListApplicationSubscriptionsQuery = {
  listApplicationSubscriptions?:  {
    __typename: "ModelApplicationSubscriptionConnection",
    items:  Array< {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncApplicationSubscriptionsQueryVariables = {
  filter?: ModelApplicationSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncApplicationSubscriptionsQuery = {
  syncApplicationSubscriptions?:  {
    __typename: "ModelApplicationSubscriptionConnection",
    items:  Array< {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationSubscriptionsByClientIdQueryVariables = {
  clientId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationSubscriptionsByClientIdQuery = {
  applicationSubscriptionsByClientId?:  {
    __typename: "ModelApplicationSubscriptionConnection",
    items:  Array< {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationSubscriptionsByStatusAndStartDateQueryVariables = {
  status: ApplicationSubscriptionStatus,
  startDate?: AdminModelStringKeyConditionInput | null,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationSubscriptionsByStatusAndStartDateQuery = {
  applicationSubscriptionsByStatusAndStartDate?:  {
    __typename: "ModelApplicationSubscriptionConnection",
    items:  Array< {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetApplicationSubscriptionVariousOperationQueryVariables = {
  id: string,
};

export type GetApplicationSubscriptionVariousOperationQuery = {
  getApplicationSubscriptionVariousOperation?:  {
    __typename: "ApplicationSubscriptionVariousOperation",
    id: string,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate?: string | null,
    label: string,
    lastInvoiceDate?: string | null,
    sellerId: string,
    startDate: string,
    subscriptionVariousOperationHistories:  Array< {
      __typename: "SubscriptionVariousOperationHistory",
      periodFrom: string,
      periodTo?: string | null,
      amount: number,
    } >,
    type: ApplicationVariousOperationType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListApplicationSubscriptionVariousOperationsQueryVariables = {
  filter?: ModelApplicationSubscriptionVariousOperationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListApplicationSubscriptionVariousOperationsQuery = {
  listApplicationSubscriptionVariousOperations?:  {
    __typename: "ModelApplicationSubscriptionVariousOperationConnection",
    items:  Array< {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncApplicationSubscriptionVariousOperationsQueryVariables = {
  filter?: ModelApplicationSubscriptionVariousOperationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncApplicationSubscriptionVariousOperationsQuery = {
  syncApplicationSubscriptionVariousOperations?:  {
    __typename: "ModelApplicationSubscriptionVariousOperationConnection",
    items:  Array< {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationSubscriptionVariousOperationsByApplicationSubscriptionIdQueryVariables = {
  applicationSubscriptionId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationSubscriptionVariousOperationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationSubscriptionVariousOperationsByApplicationSubscriptionIdQuery = {
  applicationSubscriptionVariousOperationsByApplicationSubscriptionId?:  {
    __typename: "ModelApplicationSubscriptionVariousOperationConnection",
    items:  Array< {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ApplicationSubscriptionVariousOperationsByClientIdQueryVariables = {
  clientId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelApplicationSubscriptionVariousOperationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ApplicationSubscriptionVariousOperationsByClientIdQuery = {
  applicationSubscriptionVariousOperationsByClientId?:  {
    __typename: "ModelApplicationSubscriptionVariousOperationConnection",
    items:  Array< {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetApplicationVariousOperationQueryVariables = {
  id: string,
};

export type GetApplicationVariousOperationQuery = {
  getApplicationVariousOperation?:  {
    __typename: "ApplicationVariousOperation",
    id: string,
    amount: number,
    customerVisible: boolean,
    duration: ApplicationVariousOperationDuration,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfCredits?: number | null,
    type: ApplicationVariousOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    applicationPlanIncludedVariousOperationsId: string,
  } | null,
};

export type ListApplicationVariousOperationsQueryVariables = {
  filter?: ModelApplicationVariousOperationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListApplicationVariousOperationsQuery = {
  listApplicationVariousOperations?:  {
    __typename: "ModelApplicationVariousOperationConnection",
    items:  Array< {
      __typename: "ApplicationVariousOperation",
      id: string,
      amount: number,
      customerVisible: boolean,
      duration: ApplicationVariousOperationDuration,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfCredits?: number | null,
      type: ApplicationVariousOperationType,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      applicationPlanIncludedVariousOperationsId: string,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncApplicationVariousOperationsQueryVariables = {
  filter?: ModelApplicationVariousOperationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncApplicationVariousOperationsQuery = {
  syncApplicationVariousOperations?:  {
    __typename: "ModelApplicationVariousOperationConnection",
    items:  Array< {
      __typename: "ApplicationVariousOperation",
      id: string,
      amount: number,
      customerVisible: boolean,
      duration: ApplicationVariousOperationDuration,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfCredits?: number | null,
      type: ApplicationVariousOperationType,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      applicationPlanIncludedVariousOperationsId: string,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCompanyUserQueryVariables = {
  id: string,
};

export type GetCompanyUserQuery = {
  getCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    cognitoSub?: string | null,
    email: string,
    firstName: string,
    language?: Language | null,
    lastName: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCompanyUsersQueryVariables = {
  filter?: ModelCompanyUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyUsersQuery = {
  listCompanyUsers?:  {
    __typename: "ModelCompanyUserConnection",
    items:  Array< {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCompanyUsersQueryVariables = {
  filter?: ModelCompanyUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCompanyUsersQuery = {
  syncCompanyUsers?:  {
    __typename: "ModelCompanyUserConnection",
    items:  Array< {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type CompanyUsersByEmailQueryVariables = {
  email: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelCompanyUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CompanyUsersByEmailQuery = {
  companyUsersByEmail?:  {
    __typename: "ModelCompanyUserConnection",
    items:  Array< {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCreditCostQueryVariables = {
  id: string,
};

export type GetCreditCostQuery = {
  getCreditCost?:  {
    __typename: "CreditCost",
    id: string,
    clientId?: string | null,
    endDate?: string | null,
    numberOfCredits: number,
    price: number,
    startDate: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCreditCostsQueryVariables = {
  filter?: ModelCreditCostFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCreditCostsQuery = {
  listCreditCosts?:  {
    __typename: "ModelCreditCostConnection",
    items:  Array< {
      __typename: "CreditCost",
      id: string,
      clientId?: string | null,
      endDate?: string | null,
      numberOfCredits: number,
      price: number,
      startDate: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCreditCostsQueryVariables = {
  filter?: ModelCreditCostFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCreditCostsQuery = {
  syncCreditCosts?:  {
    __typename: "ModelCreditCostConnection",
    items:  Array< {
      __typename: "CreditCost",
      id: string,
      clientId?: string | null,
      endDate?: string | null,
      numberOfCredits: number,
      price: number,
      startDate: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type CreditCostsByClientIdAndStartDateQueryVariables = {
  clientId: string,
  startDate?: AdminModelStringKeyConditionInput | null,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelCreditCostFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CreditCostsByClientIdAndStartDateQuery = {
  creditCostsByClientIdAndStartDate?:  {
    __typename: "ModelCreditCostConnection",
    items:  Array< {
      __typename: "CreditCost",
      id: string,
      clientId?: string | null,
      endDate?: string | null,
      numberOfCredits: number,
      price: number,
      startDate: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCreditUsageCostQueryVariables = {
  id: string,
};

export type GetCreditUsageCostQuery = {
  getCreditUsageCost?:  {
    __typename: "CreditUsageCost",
    id: string,
    endDate?: string | null,
    numberOfCreditsPerOperation: number,
    startDate: string,
    type: CreditOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCreditUsageCostsQueryVariables = {
  filter?: ModelCreditUsageCostFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCreditUsageCostsQuery = {
  listCreditUsageCosts?:  {
    __typename: "ModelCreditUsageCostConnection",
    items:  Array< {
      __typename: "CreditUsageCost",
      id: string,
      endDate?: string | null,
      numberOfCreditsPerOperation: number,
      startDate: string,
      type: CreditOperationType,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCreditUsageCostsQueryVariables = {
  filter?: ModelCreditUsageCostFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCreditUsageCostsQuery = {
  syncCreditUsageCosts?:  {
    __typename: "ModelCreditUsageCostConnection",
    items:  Array< {
      __typename: "CreditUsageCost",
      id: string,
      endDate?: string | null,
      numberOfCreditsPerOperation: number,
      startDate: string,
      type: CreditOperationType,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSubscriptionUsageHistoryQueryVariables = {
  id: string,
};

export type GetSubscriptionUsageHistoryQuery = {
  getSubscriptionUsageHistory?:  {
    __typename: "SubscriptionUsageHistory",
    id: string,
    clientId: string,
    createdAt: string,
    creditUsageDetail?:  {
      __typename: "SubscriptionCreditUsageHistoryDetail",
      numberUsed: number,
      creditsAccount: CreditsAccount,
      creditOperationType: CreditOperationType,
    } | null,
    customerCreatorId?: string | null,
    requestId?: string | null,
    applicationInvoiceId?: string | null,
    storageUsageDetail?:  {
      __typename: "SubscriptionStorageUsageHistoryDetail",
      numberUsed: number,
    } | null,
    type: UsageType,
    unitsUsageDetail?:  {
      __typename: "SubscriptionUnitsUsageHistoryDetail",
      unitsUsage:  Array< {
        __typename: "SubscriptionUnitUsageHistoryDetail",
        numberUsed: number,
        unitId?: string | null,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
      proRataUnits:  Array< {
        __typename: "SubscriptionUnitProRataUsageHistoryDetail",
        unitId: string,
        numberOfDays: number,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSubscriptionUsageHistoriesQueryVariables = {
  filter?: ModelSubscriptionUsageHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubscriptionUsageHistoriesQuery = {
  listSubscriptionUsageHistories?:  {
    __typename: "ModelSubscriptionUsageHistoryConnection",
    items:  Array< {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSubscriptionUsageHistoriesQueryVariables = {
  filter?: ModelSubscriptionUsageHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSubscriptionUsageHistoriesQuery = {
  syncSubscriptionUsageHistories?:  {
    __typename: "ModelSubscriptionUsageHistoryConnection",
    items:  Array< {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SubscriptionUsageHistoriesByClientIdAndCreatedAtQueryVariables = {
  clientId: string,
  createdAt?: AdminModelStringKeyConditionInput | null,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelSubscriptionUsageHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SubscriptionUsageHistoriesByClientIdAndCreatedAtQuery = {
  subscriptionUsageHistoriesByClientIdAndCreatedAt?:  {
    __typename: "ModelSubscriptionUsageHistoryConnection",
    items:  Array< {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SubscriptionUsageHistoriesByRequestIdAndCreatedAtQueryVariables = {
  requestId: string,
  createdAt?: AdminModelStringKeyConditionInput | null,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelSubscriptionUsageHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SubscriptionUsageHistoriesByRequestIdAndCreatedAtQuery = {
  subscriptionUsageHistoriesByRequestIdAndCreatedAt?:  {
    __typename: "ModelSubscriptionUsageHistoryConnection",
    items:  Array< {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SubscriptionUsageHistoriesByApplicationInvoiceIdQueryVariables = {
  applicationInvoiceId: string,
  sortDirection?: AdminModelSortDirection | null,
  filter?: ModelSubscriptionUsageHistoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SubscriptionUsageHistoriesByApplicationInvoiceIdQuery = {
  subscriptionUsageHistoriesByApplicationInvoiceId?:  {
    __typename: "ModelSubscriptionUsageHistoryConnection",
    items:  Array< {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCreditCostsForClientQueryVariables = {
  filter: ModelCreditCostFilterInput,
};

export type GetCreditCostsForClientQuery = {
  getCreditCostsForClient?:  {
    __typename: "ModelCreditCostConnection",
    items:  Array< {
      __typename: "CreditCost",
      id: string,
      clientId?: string | null,
      endDate?: string | null,
      numberOfCredits: number,
      price: number,
      startDate: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type OnCreateDocumentNumberSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentNumberFilterInput | null,
};

export type OnCreateDocumentNumberSubscription = {
  onCreateDocumentNumber?:  {
    __typename: "DocumentNumber",
    id: string,
    format: string,
    lastUpdate: string,
    incrementNumber: number,
    type: ApplicationInvoiceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateDocumentNumberSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentNumberFilterInput | null,
};

export type OnUpdateDocumentNumberSubscription = {
  onUpdateDocumentNumber?:  {
    __typename: "DocumentNumber",
    id: string,
    format: string,
    lastUpdate: string,
    incrementNumber: number,
    type: ApplicationInvoiceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteDocumentNumberSubscriptionVariables = {
  filter?: ModelSubscriptionDocumentNumberFilterInput | null,
};

export type OnDeleteDocumentNumberSubscription = {
  onDeleteDocumentNumber?:  {
    __typename: "DocumentNumber",
    id: string,
    format: string,
    lastUpdate: string,
    incrementNumber: number,
    type: ApplicationInvoiceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAdminCommunicationSubscriptionVariables = {
  filter?: ModelSubscriptionAdminCommunicationFilterInput | null,
};

export type OnCreateAdminCommunicationSubscription = {
  onCreateAdminCommunication?:  {
    __typename: "AdminCommunication",
    id: string,
    body: string,
    clientId: string,
    createdAt: string,
    externalId?: string | null,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    applicationInvoiceId?: string | null,
    recipient?: string | null,
    sentAt?: string | null,
    status: AdminCommunicationStatus,
    subject: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAdminCommunicationSubscriptionVariables = {
  filter?: ModelSubscriptionAdminCommunicationFilterInput | null,
};

export type OnUpdateAdminCommunicationSubscription = {
  onUpdateAdminCommunication?:  {
    __typename: "AdminCommunication",
    id: string,
    body: string,
    clientId: string,
    createdAt: string,
    externalId?: string | null,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    applicationInvoiceId?: string | null,
    recipient?: string | null,
    sentAt?: string | null,
    status: AdminCommunicationStatus,
    subject: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAdminCommunicationSubscriptionVariables = {
  filter?: ModelSubscriptionAdminCommunicationFilterInput | null,
};

export type OnDeleteAdminCommunicationSubscription = {
  onDeleteAdminCommunication?:  {
    __typename: "AdminCommunication",
    id: string,
    body: string,
    clientId: string,
    createdAt: string,
    externalId?: string | null,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    applicationInvoiceId?: string | null,
    recipient?: string | null,
    sentAt?: string | null,
    status: AdminCommunicationStatus,
    subject: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAdminFileSubscriptionVariables = {
  filter?: ModelSubscriptionAdminFileFilterInput | null,
};

export type OnCreateAdminFileSubscription = {
  onCreateAdminFile?:  {
    __typename: "AdminFile",
    id: string,
    bucket: string,
    createdAt: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    size?: number | null,
    clientId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAdminFileSubscriptionVariables = {
  filter?: ModelSubscriptionAdminFileFilterInput | null,
};

export type OnUpdateAdminFileSubscription = {
  onUpdateAdminFile?:  {
    __typename: "AdminFile",
    id: string,
    bucket: string,
    createdAt: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    size?: number | null,
    clientId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAdminFileSubscriptionVariables = {
  filter?: ModelSubscriptionAdminFileFilterInput | null,
};

export type OnDeleteAdminFileSubscription = {
  onDeleteAdminFile?:  {
    __typename: "AdminFile",
    id: string,
    bucket: string,
    createdAt: string,
    foreignKey: string,
    foreignTableName: string,
    key: string,
    mimeType?: string | null,
    region: string,
    size?: number | null,
    clientId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateApplicationInvoiceSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationInvoiceFilterInput | null,
};

export type OnCreateApplicationInvoiceSubscription = {
  onCreateApplicationInvoice?:  {
    __typename: "ApplicationInvoice",
    id: string,
    amount: number,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceLines?:  {
      __typename: "ModelApplicationInvoiceLineConnection",
      items:  Array< {
        __typename: "ApplicationInvoiceLine",
        id: string,
        amountVatExcluded: number,
        applicationInvoiceId: string,
        calculationMethod?: ApplicationPlanCalculationMethod | null,
        clientId: string,
        customLabel?: string | null,
        extraInformation?: ApplicationInvoiceLineExtraInformation | null,
        quantity: number,
        periodFrom?: string | null,
        periodTo?: string | null,
        subscriptionVariousOperationId?: string | null,
        subscriptionUsageHistoryId?: string | null,
        totalAmount: number,
        type: ApplicationInvoiceLineType,
        vatAmount?: number | null,
        vatRate?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoiceNumber?: string | null,
    periodFrom: string,
    periodTo: string,
    clientSnapshot?:  {
      __typename: "ApplicationInvoiceClientSnapshot",
      name: string,
      vat?: string | null,
      businessNumber?: string | null,
      email?: string | null,
      address?:  {
        __typename: "ApplicationInvoiceClientSnapshotAddress",
        street?: string | null,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        country?: string | null,
      } | null,
    } | null,
    peppolProperties?:  {
      __typename: "ApplicationInvoicePeppolProperties",
      peppolStatus?: InvoicePeppolStatus | null,
      peppolId?: string | null,
      peppolErrorType?: string | null,
      peppolErrorMessage?: string | null,
    } | null,
    status: ApplicationInvoiceStatus,
    type: ApplicationInvoiceType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateApplicationInvoiceSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationInvoiceFilterInput | null,
};

export type OnUpdateApplicationInvoiceSubscription = {
  onUpdateApplicationInvoice?:  {
    __typename: "ApplicationInvoice",
    id: string,
    amount: number,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceLines?:  {
      __typename: "ModelApplicationInvoiceLineConnection",
      items:  Array< {
        __typename: "ApplicationInvoiceLine",
        id: string,
        amountVatExcluded: number,
        applicationInvoiceId: string,
        calculationMethod?: ApplicationPlanCalculationMethod | null,
        clientId: string,
        customLabel?: string | null,
        extraInformation?: ApplicationInvoiceLineExtraInformation | null,
        quantity: number,
        periodFrom?: string | null,
        periodTo?: string | null,
        subscriptionVariousOperationId?: string | null,
        subscriptionUsageHistoryId?: string | null,
        totalAmount: number,
        type: ApplicationInvoiceLineType,
        vatAmount?: number | null,
        vatRate?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoiceNumber?: string | null,
    periodFrom: string,
    periodTo: string,
    clientSnapshot?:  {
      __typename: "ApplicationInvoiceClientSnapshot",
      name: string,
      vat?: string | null,
      businessNumber?: string | null,
      email?: string | null,
      address?:  {
        __typename: "ApplicationInvoiceClientSnapshotAddress",
        street?: string | null,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        country?: string | null,
      } | null,
    } | null,
    peppolProperties?:  {
      __typename: "ApplicationInvoicePeppolProperties",
      peppolStatus?: InvoicePeppolStatus | null,
      peppolId?: string | null,
      peppolErrorType?: string | null,
      peppolErrorMessage?: string | null,
    } | null,
    status: ApplicationInvoiceStatus,
    type: ApplicationInvoiceType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteApplicationInvoiceSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationInvoiceFilterInput | null,
};

export type OnDeleteApplicationInvoiceSubscription = {
  onDeleteApplicationInvoice?:  {
    __typename: "ApplicationInvoice",
    id: string,
    amount: number,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    dueDate?: string | null,
    invoiceDate: string,
    invoiceLines?:  {
      __typename: "ModelApplicationInvoiceLineConnection",
      items:  Array< {
        __typename: "ApplicationInvoiceLine",
        id: string,
        amountVatExcluded: number,
        applicationInvoiceId: string,
        calculationMethod?: ApplicationPlanCalculationMethod | null,
        clientId: string,
        customLabel?: string | null,
        extraInformation?: ApplicationInvoiceLineExtraInformation | null,
        quantity: number,
        periodFrom?: string | null,
        periodTo?: string | null,
        subscriptionVariousOperationId?: string | null,
        subscriptionUsageHistoryId?: string | null,
        totalAmount: number,
        type: ApplicationInvoiceLineType,
        vatAmount?: number | null,
        vatRate?: number | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    invoiceNumber?: string | null,
    periodFrom: string,
    periodTo: string,
    clientSnapshot?:  {
      __typename: "ApplicationInvoiceClientSnapshot",
      name: string,
      vat?: string | null,
      businessNumber?: string | null,
      email?: string | null,
      address?:  {
        __typename: "ApplicationInvoiceClientSnapshotAddress",
        street?: string | null,
        number?: string | null,
        box?: string | null,
        postalCode?: string | null,
        city?: string | null,
        country?: string | null,
      } | null,
    } | null,
    peppolProperties?:  {
      __typename: "ApplicationInvoicePeppolProperties",
      peppolStatus?: InvoicePeppolStatus | null,
      peppolId?: string | null,
      peppolErrorType?: string | null,
      peppolErrorMessage?: string | null,
    } | null,
    status: ApplicationInvoiceStatus,
    type: ApplicationInvoiceType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateApplicationInvoiceLineSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationInvoiceLineFilterInput | null,
};

export type OnCreateApplicationInvoiceLineSubscription = {
  onCreateApplicationInvoiceLine?:  {
    __typename: "ApplicationInvoiceLine",
    id: string,
    amountVatExcluded: number,
    applicationInvoiceId: string,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    calculationDetail?:  {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } | null,
    calculationMethod?: ApplicationPlanCalculationMethod | null,
    clientId: string,
    customLabel?: string | null,
    extraInformation?: ApplicationInvoiceLineExtraInformation | null,
    quantity: number,
    periodFrom?: string | null,
    periodTo?: string | null,
    subscriptionVariousOperationId?: string | null,
    subscriptionVariousOperation?:  {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    subscriptionUsageHistoryId?: string | null,
    subscriptionUsageHistory?:  {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    totalAmount: number,
    type: ApplicationInvoiceLineType,
    vatAmount?: number | null,
    vatRate?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateApplicationInvoiceLineSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationInvoiceLineFilterInput | null,
};

export type OnUpdateApplicationInvoiceLineSubscription = {
  onUpdateApplicationInvoiceLine?:  {
    __typename: "ApplicationInvoiceLine",
    id: string,
    amountVatExcluded: number,
    applicationInvoiceId: string,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    calculationDetail?:  {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } | null,
    calculationMethod?: ApplicationPlanCalculationMethod | null,
    clientId: string,
    customLabel?: string | null,
    extraInformation?: ApplicationInvoiceLineExtraInformation | null,
    quantity: number,
    periodFrom?: string | null,
    periodTo?: string | null,
    subscriptionVariousOperationId?: string | null,
    subscriptionVariousOperation?:  {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    subscriptionUsageHistoryId?: string | null,
    subscriptionUsageHistory?:  {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    totalAmount: number,
    type: ApplicationInvoiceLineType,
    vatAmount?: number | null,
    vatRate?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteApplicationInvoiceLineSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationInvoiceLineFilterInput | null,
};

export type OnDeleteApplicationInvoiceLineSubscription = {
  onDeleteApplicationInvoiceLine?:  {
    __typename: "ApplicationInvoiceLine",
    id: string,
    amountVatExcluded: number,
    applicationInvoiceId: string,
    applicationInvoice?:  {
      __typename: "ApplicationInvoice",
      id: string,
      amount: number,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      dueDate?: string | null,
      invoiceDate: string,
      invoiceLines?:  {
        __typename: "ModelApplicationInvoiceLineConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      invoiceNumber?: string | null,
      periodFrom: string,
      periodTo: string,
      clientSnapshot?:  {
        __typename: "ApplicationInvoiceClientSnapshot",
        name: string,
        vat?: string | null,
        businessNumber?: string | null,
        email?: string | null,
      } | null,
      peppolProperties?:  {
        __typename: "ApplicationInvoicePeppolProperties",
        peppolStatus?: InvoicePeppolStatus | null,
        peppolId?: string | null,
        peppolErrorType?: string | null,
        peppolErrorMessage?: string | null,
      } | null,
      status: ApplicationInvoiceStatus,
      type: ApplicationInvoiceType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    calculationDetail?:  {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } | null,
    calculationMethod?: ApplicationPlanCalculationMethod | null,
    clientId: string,
    customLabel?: string | null,
    extraInformation?: ApplicationInvoiceLineExtraInformation | null,
    quantity: number,
    periodFrom?: string | null,
    periodTo?: string | null,
    subscriptionVariousOperationId?: string | null,
    subscriptionVariousOperation?:  {
      __typename: "ApplicationSubscriptionVariousOperation",
      id: string,
      applicationSubscriptionId: string,
      applicationSubscription?:  {
        __typename: "ApplicationSubscription",
        id: string,
        clientId: string,
        creditsBalancePaid: number,
        creditsBalanceIncluded: number,
        endDate?: string | null,
        language: Language,
        lastInvoiceDate?: string | null,
        paymentCustomerId?: string | null,
        paymentLastExecution?: string | null,
        paymentLastStatus: PaymentStatus,
        paymentLastError?: string | null,
        paymentMethodId?: string | null,
        paymentMode: PaymentMode,
        paymentTerms: PaymentTerms,
        planId: string,
        referenceNumber?: string | null,
        sellerId?: string | null,
        startDate: string,
        status: ApplicationSubscriptionStatus,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      clientId: string,
      createdAt: string,
      createdBy?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      endDate?: string | null,
      label: string,
      lastInvoiceDate?: string | null,
      sellerId: string,
      startDate: string,
      subscriptionVariousOperationHistories:  Array< {
        __typename: "SubscriptionVariousOperationHistory",
        periodFrom: string,
        periodTo?: string | null,
        amount: number,
      } >,
      type: ApplicationVariousOperationType,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    subscriptionUsageHistoryId?: string | null,
    subscriptionUsageHistory?:  {
      __typename: "SubscriptionUsageHistory",
      id: string,
      clientId: string,
      createdAt: string,
      creditUsageDetail?:  {
        __typename: "SubscriptionCreditUsageHistoryDetail",
        numberUsed: number,
        creditsAccount: CreditsAccount,
        creditOperationType: CreditOperationType,
      } | null,
      customerCreatorId?: string | null,
      requestId?: string | null,
      applicationInvoiceId?: string | null,
      storageUsageDetail?:  {
        __typename: "SubscriptionStorageUsageHistoryDetail",
        numberUsed: number,
      } | null,
      type: UsageType,
      unitsUsageDetail?:  {
        __typename: "SubscriptionUnitsUsageHistoryDetail",
      } | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    totalAmount: number,
    type: ApplicationInvoiceLineType,
    vatAmount?: number | null,
    vatRate?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateApplicationPlanSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationPlanFilterInput | null,
};

export type OnCreateApplicationPlanSubscription = {
  onCreateApplicationPlan?:  {
    __typename: "ApplicationPlan",
    id: string,
    calculationDetails:  Array< {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } >,
    calculationMethod: ApplicationPlanCalculationMethod,
    includedVariousOperations?:  {
      __typename: "ModelApplicationVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationVariousOperation",
        id: string,
        amount: number,
        customerVisible: boolean,
        duration: ApplicationVariousOperationDuration,
        numberOfCredits?: number | null,
        type: ApplicationVariousOperationType,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        applicationPlanIncludedVariousOperationsId: string,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    isBillable: boolean,
    isDefaultPlan: boolean,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfTrialMonths: number,
    setupFees: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateApplicationPlanSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationPlanFilterInput | null,
};

export type OnUpdateApplicationPlanSubscription = {
  onUpdateApplicationPlan?:  {
    __typename: "ApplicationPlan",
    id: string,
    calculationDetails:  Array< {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } >,
    calculationMethod: ApplicationPlanCalculationMethod,
    includedVariousOperations?:  {
      __typename: "ModelApplicationVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationVariousOperation",
        id: string,
        amount: number,
        customerVisible: boolean,
        duration: ApplicationVariousOperationDuration,
        numberOfCredits?: number | null,
        type: ApplicationVariousOperationType,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        applicationPlanIncludedVariousOperationsId: string,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    isBillable: boolean,
    isDefaultPlan: boolean,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfTrialMonths: number,
    setupFees: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteApplicationPlanSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationPlanFilterInput | null,
};

export type OnDeleteApplicationPlanSubscription = {
  onDeleteApplicationPlan?:  {
    __typename: "ApplicationPlan",
    id: string,
    calculationDetails:  Array< {
      __typename: "ApplicationPlanCalculationDetail",
      amountType: ApplicationPlanCalculationAmountDetailType,
      endNumber?: number | null,
      feeApplied: number,
      minimumFixedUnitPriceThreshold?: number | null,
      startNumber: number,
      unitType: Array< UnitType >,
    } >,
    calculationMethod: ApplicationPlanCalculationMethod,
    includedVariousOperations?:  {
      __typename: "ModelApplicationVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationVariousOperation",
        id: string,
        amount: number,
        customerVisible: boolean,
        duration: ApplicationVariousOperationDuration,
        numberOfCredits?: number | null,
        type: ApplicationVariousOperationType,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        applicationPlanIncludedVariousOperationsId: string,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    isBillable: boolean,
    isDefaultPlan: boolean,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfTrialMonths: number,
    setupFees: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateApplicationSubscriptionSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationSubscriptionFilterInput | null,
};

export type OnCreateApplicationSubscriptionSubscription = {
  onCreateApplicationSubscription?:  {
    __typename: "ApplicationSubscription",
    id: string,
    clientId: string,
    creditsBalancePaid: number,
    creditsBalanceIncluded: number,
    creditsConfiguration:  {
      __typename: "CreditsConfiguration",
      allowPostPaid: boolean,
      creditsNotification: Array< CustomerNotification >,
      postPaidThreshold: number,
    },
    endDate?: string | null,
    language: Language,
    lastInvoiceDate?: string | null,
    paymentCustomerId?: string | null,
    paymentLastExecution?: string | null,
    paymentLastStatus: PaymentStatus,
    paymentLastError?: string | null,
    paymentMethodId?: string | null,
    paymentMode: PaymentMode,
    paymentTerms: PaymentTerms,
    invoicesProperties?:  {
      __typename: "InvoicesProperties",
      hideQuantities?: boolean | null,
    } | null,
    plan?:  {
      __typename: "ApplicationPlan",
      id: string,
      calculationDetails:  Array< {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } >,
      calculationMethod: ApplicationPlanCalculationMethod,
      includedVariousOperations?:  {
        __typename: "ModelApplicationVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      isBillable: boolean,
      isDefaultPlan: boolean,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfTrialMonths: number,
      setupFees: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    planId: string,
    referenceNumber?: string | null,
    seller?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sellerId?: string | null,
    startDate: string,
    status: ApplicationSubscriptionStatus,
    subscriptionVariousOperations?:  {
      __typename: "ModelApplicationSubscriptionVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateApplicationSubscriptionSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationSubscriptionFilterInput | null,
};

export type OnUpdateApplicationSubscriptionSubscription = {
  onUpdateApplicationSubscription?:  {
    __typename: "ApplicationSubscription",
    id: string,
    clientId: string,
    creditsBalancePaid: number,
    creditsBalanceIncluded: number,
    creditsConfiguration:  {
      __typename: "CreditsConfiguration",
      allowPostPaid: boolean,
      creditsNotification: Array< CustomerNotification >,
      postPaidThreshold: number,
    },
    endDate?: string | null,
    language: Language,
    lastInvoiceDate?: string | null,
    paymentCustomerId?: string | null,
    paymentLastExecution?: string | null,
    paymentLastStatus: PaymentStatus,
    paymentLastError?: string | null,
    paymentMethodId?: string | null,
    paymentMode: PaymentMode,
    paymentTerms: PaymentTerms,
    invoicesProperties?:  {
      __typename: "InvoicesProperties",
      hideQuantities?: boolean | null,
    } | null,
    plan?:  {
      __typename: "ApplicationPlan",
      id: string,
      calculationDetails:  Array< {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } >,
      calculationMethod: ApplicationPlanCalculationMethod,
      includedVariousOperations?:  {
        __typename: "ModelApplicationVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      isBillable: boolean,
      isDefaultPlan: boolean,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfTrialMonths: number,
      setupFees: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    planId: string,
    referenceNumber?: string | null,
    seller?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sellerId?: string | null,
    startDate: string,
    status: ApplicationSubscriptionStatus,
    subscriptionVariousOperations?:  {
      __typename: "ModelApplicationSubscriptionVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteApplicationSubscriptionSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationSubscriptionFilterInput | null,
};

export type OnDeleteApplicationSubscriptionSubscription = {
  onDeleteApplicationSubscription?:  {
    __typename: "ApplicationSubscription",
    id: string,
    clientId: string,
    creditsBalancePaid: number,
    creditsBalanceIncluded: number,
    creditsConfiguration:  {
      __typename: "CreditsConfiguration",
      allowPostPaid: boolean,
      creditsNotification: Array< CustomerNotification >,
      postPaidThreshold: number,
    },
    endDate?: string | null,
    language: Language,
    lastInvoiceDate?: string | null,
    paymentCustomerId?: string | null,
    paymentLastExecution?: string | null,
    paymentLastStatus: PaymentStatus,
    paymentLastError?: string | null,
    paymentMethodId?: string | null,
    paymentMode: PaymentMode,
    paymentTerms: PaymentTerms,
    invoicesProperties?:  {
      __typename: "InvoicesProperties",
      hideQuantities?: boolean | null,
    } | null,
    plan?:  {
      __typename: "ApplicationPlan",
      id: string,
      calculationDetails:  Array< {
        __typename: "ApplicationPlanCalculationDetail",
        amountType: ApplicationPlanCalculationAmountDetailType,
        endNumber?: number | null,
        feeApplied: number,
        minimumFixedUnitPriceThreshold?: number | null,
        startNumber: number,
        unitType: Array< UnitType >,
      } >,
      calculationMethod: ApplicationPlanCalculationMethod,
      includedVariousOperations?:  {
        __typename: "ModelApplicationVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      isBillable: boolean,
      isDefaultPlan: boolean,
      labels:  Array< {
        __typename: "Label",
        language: Language,
        label: string,
      } >,
      numberOfTrialMonths: number,
      setupFees: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    planId: string,
    referenceNumber?: string | null,
    seller?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sellerId?: string | null,
    startDate: string,
    status: ApplicationSubscriptionStatus,
    subscriptionVariousOperations?:  {
      __typename: "ModelApplicationSubscriptionVariousOperationConnection",
      items:  Array< {
        __typename: "ApplicationSubscriptionVariousOperation",
        id: string,
        applicationSubscriptionId: string,
        clientId: string,
        createdAt: string,
        endDate?: string | null,
        label: string,
        lastInvoiceDate?: string | null,
        sellerId: string,
        startDate: string,
        type: ApplicationVariousOperationType,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateApplicationSubscriptionVariousOperationSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationSubscriptionVariousOperationFilterInput | null,
};

export type OnCreateApplicationSubscriptionVariousOperationSubscription = {
  onCreateApplicationSubscriptionVariousOperation?:  {
    __typename: "ApplicationSubscriptionVariousOperation",
    id: string,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate?: string | null,
    label: string,
    lastInvoiceDate?: string | null,
    sellerId: string,
    startDate: string,
    subscriptionVariousOperationHistories:  Array< {
      __typename: "SubscriptionVariousOperationHistory",
      periodFrom: string,
      periodTo?: string | null,
      amount: number,
    } >,
    type: ApplicationVariousOperationType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateApplicationSubscriptionVariousOperationSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationSubscriptionVariousOperationFilterInput | null,
};

export type OnUpdateApplicationSubscriptionVariousOperationSubscription = {
  onUpdateApplicationSubscriptionVariousOperation?:  {
    __typename: "ApplicationSubscriptionVariousOperation",
    id: string,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate?: string | null,
    label: string,
    lastInvoiceDate?: string | null,
    sellerId: string,
    startDate: string,
    subscriptionVariousOperationHistories:  Array< {
      __typename: "SubscriptionVariousOperationHistory",
      periodFrom: string,
      periodTo?: string | null,
      amount: number,
    } >,
    type: ApplicationVariousOperationType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteApplicationSubscriptionVariousOperationSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationSubscriptionVariousOperationFilterInput | null,
};

export type OnDeleteApplicationSubscriptionVariousOperationSubscription = {
  onDeleteApplicationSubscriptionVariousOperation?:  {
    __typename: "ApplicationSubscriptionVariousOperation",
    id: string,
    applicationSubscriptionId: string,
    applicationSubscription?:  {
      __typename: "ApplicationSubscription",
      id: string,
      clientId: string,
      creditsBalancePaid: number,
      creditsBalanceIncluded: number,
      creditsConfiguration:  {
        __typename: "CreditsConfiguration",
        allowPostPaid: boolean,
        creditsNotification: Array< CustomerNotification >,
        postPaidThreshold: number,
      },
      endDate?: string | null,
      language: Language,
      lastInvoiceDate?: string | null,
      paymentCustomerId?: string | null,
      paymentLastExecution?: string | null,
      paymentLastStatus: PaymentStatus,
      paymentLastError?: string | null,
      paymentMethodId?: string | null,
      paymentMode: PaymentMode,
      paymentTerms: PaymentTerms,
      invoicesProperties?:  {
        __typename: "InvoicesProperties",
        hideQuantities?: boolean | null,
      } | null,
      plan?:  {
        __typename: "ApplicationPlan",
        id: string,
        calculationMethod: ApplicationPlanCalculationMethod,
        isBillable: boolean,
        isDefaultPlan: boolean,
        numberOfTrialMonths: number,
        setupFees: number,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      planId: string,
      referenceNumber?: string | null,
      seller?:  {
        __typename: "CompanyUser",
        id: string,
        cognitoSub?: string | null,
        email: string,
        firstName: string,
        language?: Language | null,
        lastName: string,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sellerId?: string | null,
      startDate: string,
      status: ApplicationSubscriptionStatus,
      subscriptionVariousOperations?:  {
        __typename: "ModelApplicationSubscriptionVariousOperationConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    clientId: string,
    createdAt: string,
    createdBy?:  {
      __typename: "CompanyUser",
      id: string,
      cognitoSub?: string | null,
      email: string,
      firstName: string,
      language?: Language | null,
      lastName: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    endDate?: string | null,
    label: string,
    lastInvoiceDate?: string | null,
    sellerId: string,
    startDate: string,
    subscriptionVariousOperationHistories:  Array< {
      __typename: "SubscriptionVariousOperationHistory",
      periodFrom: string,
      periodTo?: string | null,
      amount: number,
    } >,
    type: ApplicationVariousOperationType,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateApplicationVariousOperationSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationVariousOperationFilterInput | null,
};

export type OnCreateApplicationVariousOperationSubscription = {
  onCreateApplicationVariousOperation?:  {
    __typename: "ApplicationVariousOperation",
    id: string,
    amount: number,
    customerVisible: boolean,
    duration: ApplicationVariousOperationDuration,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfCredits?: number | null,
    type: ApplicationVariousOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    applicationPlanIncludedVariousOperationsId: string,
  } | null,
};

export type OnUpdateApplicationVariousOperationSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationVariousOperationFilterInput | null,
};

export type OnUpdateApplicationVariousOperationSubscription = {
  onUpdateApplicationVariousOperation?:  {
    __typename: "ApplicationVariousOperation",
    id: string,
    amount: number,
    customerVisible: boolean,
    duration: ApplicationVariousOperationDuration,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfCredits?: number | null,
    type: ApplicationVariousOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    applicationPlanIncludedVariousOperationsId: string,
  } | null,
};

export type OnDeleteApplicationVariousOperationSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationVariousOperationFilterInput | null,
};

export type OnDeleteApplicationVariousOperationSubscription = {
  onDeleteApplicationVariousOperation?:  {
    __typename: "ApplicationVariousOperation",
    id: string,
    amount: number,
    customerVisible: boolean,
    duration: ApplicationVariousOperationDuration,
    labels:  Array< {
      __typename: "Label",
      language: Language,
      label: string,
    } >,
    numberOfCredits?: number | null,
    type: ApplicationVariousOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    applicationPlanIncludedVariousOperationsId: string,
  } | null,
};

export type OnCreateCompanyUserSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyUserFilterInput | null,
};

export type OnCreateCompanyUserSubscription = {
  onCreateCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    cognitoSub?: string | null,
    email: string,
    firstName: string,
    language?: Language | null,
    lastName: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCompanyUserSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyUserFilterInput | null,
};

export type OnUpdateCompanyUserSubscription = {
  onUpdateCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    cognitoSub?: string | null,
    email: string,
    firstName: string,
    language?: Language | null,
    lastName: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCompanyUserSubscriptionVariables = {
  filter?: ModelSubscriptionCompanyUserFilterInput | null,
};

export type OnDeleteCompanyUserSubscription = {
  onDeleteCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    cognitoSub?: string | null,
    email: string,
    firstName: string,
    language?: Language | null,
    lastName: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateCreditCostSubscriptionVariables = {
  filter?: ModelSubscriptionCreditCostFilterInput | null,
};

export type OnCreateCreditCostSubscription = {
  onCreateCreditCost?:  {
    __typename: "CreditCost",
    id: string,
    clientId?: string | null,
    endDate?: string | null,
    numberOfCredits: number,
    price: number,
    startDate: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCreditCostSubscriptionVariables = {
  filter?: ModelSubscriptionCreditCostFilterInput | null,
};

export type OnUpdateCreditCostSubscription = {
  onUpdateCreditCost?:  {
    __typename: "CreditCost",
    id: string,
    clientId?: string | null,
    endDate?: string | null,
    numberOfCredits: number,
    price: number,
    startDate: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCreditCostSubscriptionVariables = {
  filter?: ModelSubscriptionCreditCostFilterInput | null,
};

export type OnDeleteCreditCostSubscription = {
  onDeleteCreditCost?:  {
    __typename: "CreditCost",
    id: string,
    clientId?: string | null,
    endDate?: string | null,
    numberOfCredits: number,
    price: number,
    startDate: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateCreditUsageCostSubscriptionVariables = {
  filter?: ModelSubscriptionCreditUsageCostFilterInput | null,
};

export type OnCreateCreditUsageCostSubscription = {
  onCreateCreditUsageCost?:  {
    __typename: "CreditUsageCost",
    id: string,
    endDate?: string | null,
    numberOfCreditsPerOperation: number,
    startDate: string,
    type: CreditOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCreditUsageCostSubscriptionVariables = {
  filter?: ModelSubscriptionCreditUsageCostFilterInput | null,
};

export type OnUpdateCreditUsageCostSubscription = {
  onUpdateCreditUsageCost?:  {
    __typename: "CreditUsageCost",
    id: string,
    endDate?: string | null,
    numberOfCreditsPerOperation: number,
    startDate: string,
    type: CreditOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCreditUsageCostSubscriptionVariables = {
  filter?: ModelSubscriptionCreditUsageCostFilterInput | null,
};

export type OnDeleteCreditUsageCostSubscription = {
  onDeleteCreditUsageCost?:  {
    __typename: "CreditUsageCost",
    id: string,
    endDate?: string | null,
    numberOfCreditsPerOperation: number,
    startDate: string,
    type: CreditOperationType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateSubscriptionUsageHistorySubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionUsageHistoryFilterInput | null,
};

export type OnCreateSubscriptionUsageHistorySubscription = {
  onCreateSubscriptionUsageHistory?:  {
    __typename: "SubscriptionUsageHistory",
    id: string,
    clientId: string,
    createdAt: string,
    creditUsageDetail?:  {
      __typename: "SubscriptionCreditUsageHistoryDetail",
      numberUsed: number,
      creditsAccount: CreditsAccount,
      creditOperationType: CreditOperationType,
    } | null,
    customerCreatorId?: string | null,
    requestId?: string | null,
    applicationInvoiceId?: string | null,
    storageUsageDetail?:  {
      __typename: "SubscriptionStorageUsageHistoryDetail",
      numberUsed: number,
    } | null,
    type: UsageType,
    unitsUsageDetail?:  {
      __typename: "SubscriptionUnitsUsageHistoryDetail",
      unitsUsage:  Array< {
        __typename: "SubscriptionUnitUsageHistoryDetail",
        numberUsed: number,
        unitId?: string | null,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
      proRataUnits:  Array< {
        __typename: "SubscriptionUnitProRataUsageHistoryDetail",
        unitId: string,
        numberOfDays: number,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSubscriptionUsageHistorySubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionUsageHistoryFilterInput | null,
};

export type OnUpdateSubscriptionUsageHistorySubscription = {
  onUpdateSubscriptionUsageHistory?:  {
    __typename: "SubscriptionUsageHistory",
    id: string,
    clientId: string,
    createdAt: string,
    creditUsageDetail?:  {
      __typename: "SubscriptionCreditUsageHistoryDetail",
      numberUsed: number,
      creditsAccount: CreditsAccount,
      creditOperationType: CreditOperationType,
    } | null,
    customerCreatorId?: string | null,
    requestId?: string | null,
    applicationInvoiceId?: string | null,
    storageUsageDetail?:  {
      __typename: "SubscriptionStorageUsageHistoryDetail",
      numberUsed: number,
    } | null,
    type: UsageType,
    unitsUsageDetail?:  {
      __typename: "SubscriptionUnitsUsageHistoryDetail",
      unitsUsage:  Array< {
        __typename: "SubscriptionUnitUsageHistoryDetail",
        numberUsed: number,
        unitId?: string | null,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
      proRataUnits:  Array< {
        __typename: "SubscriptionUnitProRataUsageHistoryDetail",
        unitId: string,
        numberOfDays: number,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSubscriptionUsageHistorySubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionUsageHistoryFilterInput | null,
};

export type OnDeleteSubscriptionUsageHistorySubscription = {
  onDeleteSubscriptionUsageHistory?:  {
    __typename: "SubscriptionUsageHistory",
    id: string,
    clientId: string,
    createdAt: string,
    creditUsageDetail?:  {
      __typename: "SubscriptionCreditUsageHistoryDetail",
      numberUsed: number,
      creditsAccount: CreditsAccount,
      creditOperationType: CreditOperationType,
    } | null,
    customerCreatorId?: string | null,
    requestId?: string | null,
    applicationInvoiceId?: string | null,
    storageUsageDetail?:  {
      __typename: "SubscriptionStorageUsageHistoryDetail",
      numberUsed: number,
    } | null,
    type: UsageType,
    unitsUsageDetail?:  {
      __typename: "SubscriptionUnitsUsageHistoryDetail",
      unitsUsage:  Array< {
        __typename: "SubscriptionUnitUsageHistoryDetail",
        numberUsed: number,
        unitId?: string | null,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
      proRataUnits:  Array< {
        __typename: "SubscriptionUnitProRataUsageHistoryDetail",
        unitId: string,
        numberOfDays: number,
        lastKnownLeasePrice?: number | null,
        advertisedRentalPrice?: number | null,
        type?: UnitType | null,
      } >,
    } | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};
